import React, {useEffect, useRef, useState} from "react";
import '../../css/web/UserMyPg.css';
import mypgOrder from "../../assets/img/mypgOrder.png";
import mypgDelivery from "../../assets/img/mypgDelivery.png";
import mypgReturn from "../../assets/img/mypgReturn.png";
import mypgReturnIcon from "../../assets/img/mypgReturnIcon.png";
import mypgOrderdt from "../../assets/img/mypgOrderdt.png";
import mypgPayinfo from "../../assets/img/mypgPayinfo.png";
import mypgWarn from "../../assets/img/mypgWarn.png"
import mypgPayCardOrder from "../../assets/img/mypgPayCardOrder.png"
import mypgPayCardDelivery from "../../assets/img/mypgPayCardDelivery.png"
import commonClose from "../../assets/img/commonClose.png"

import noData from "../../assets/img/noData.png";
import {AiOutlineDoubleRight} from "react-icons/ai";
import {useNavigate} from "react-router-dom";
import {BiChevronDown} from "react-icons/bi";
import axios from '../../services/axiosInstance';
import DeliveryPriceDetail from "../../components/web/modal/DeliveryPriceDetail";
import excel from "exceljs";
import withAuth from '../../auth/UserRouteAuth'
import CommonLoading from "../../components/web/modal/CommonLoading";
import IntegDetailPopup from "../../components/web/modal/IntegDetailPopup";
import MsgCheckModal from "../../components/web/modal/MsgCheckModal";
import {useTranslation} from "react-i18next";
import commomHeader from "../../assets/img/commonHeader.png";
import {useWebSocket} from "../../services/WebsocketContext";
import TopBtn from "../../components/web/layoutsadmin/TopBtn";
import i18n from "../../i18n";
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";

function UserMyPg() {

    const {t} = useTranslation();
    const navigate = useNavigate();
    const [theme] = useTheme();

    // 모바일 화면 여부(≤900px) — 탭/스택 전환용
    const [isMobileView, setIsMobileView] = useState(typeof window !== 'undefined' && window.innerWidth <= 900);
    useEffect(() => {
        const onResize = () => setIsMobileView(window.innerWidth <= 900);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);
    const SSAT = sessionStorage.getItem('AToken');
    const LCAT = localStorage.getItem('AToken');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // 주문서 기간셀렉트
    const [periodSelectShow, setPeriodSelectShow] = useState(false);
    const [periodSelectCommonValue, setPeriodSelectCommonValue] = useState(t(`myPrd1`));
    const periodButtonRef = useRef(null);
    const periodDivRef = useRef(null);

    const periodBtHandle = (newValue) => {
        setPeriodSelectShow(false);
        setPeriodSelectCommonValue(newValue);
    };
    const periodDivHandle = (event) => {
        event.stopPropagation();
    };

    useEffect(() => {
        const periodClickOutside = (event) => {
            if (
                periodButtonRef.current &&
                periodButtonRef.current.contains(event.target)
            ) {
                setPeriodSelectShow(true);
            } else if (
                periodDivRef.current &&
                !periodDivRef.current.contains(event.target)
            ) {
                setPeriodSelectShow(false);
            }
        };
        document.addEventListener('mousedown', periodClickOutside);
        return () => {
            document.removeEventListener('mousedown', periodClickOutside);
        };
    }, []);

    // 주문서 유형셀렉트
    const [orderTypeSelectShow, setOrderTypeSelectShow] = useState(false);
    const [orderTypeSelectCommonValue, setOrderTypeSelectCommonValue] = useState(t(`orderType`));
    const orderTypeButtonRef = useRef(null);
    const orderTypeDivRef = useRef(null);

    const orderTypeBtHandle = (newValue) => {
        setOrderTypeSelectShow(false);
        setOrderTypeSelectCommonValue(newValue);
    };
    const orderTypeDivHandle = (event) => {
        event.stopPropagation();
    };

    useEffect(() => {
        const orderTypeClickOutside = (event) => {
            if (
                orderTypeButtonRef.current &&
                orderTypeButtonRef.current.contains(event.target)
            ) {
                setOrderTypeSelectShow(true);
            } else if (
                orderTypeDivRef.current &&
                !orderTypeDivRef.current.contains(event.target)
            ) {
                setOrderTypeSelectShow(false);
            }
        };
        document.addEventListener('mousedown', orderTypeClickOutside);
        return () => {
            document.removeEventListener('mousedown', orderTypeClickOutside);
        };
    }, []);

    // 주문서 상태셀렉트
    const [orderStSelectShow, setOrderStSelectShow] = useState(false);
    const [orderStSelectCommonValue, setOrderStSelectCommonValue] = useState(t(`state`));
    const orderStButtonRef = useRef(null);
    const orderStDivRef = useRef(null);

    const myPgContentRef = useRef(null);
    const scrollToMyPgContent = () => {
        if (myPgContentRef.current) {
            myPgContentRef?.current.scrollIntoView({behavior: 'smooth'});
        }
    };

    const orderStBtHandle = (newValue) => {
        setOrderStSelectShow(false);
        setOrderStSelectCommonValue(newValue);
        filterOrderSt(newValue);
        scrollToMyPgContent();
    };
    const orderStDivHandle = (event) => {
        event.stopPropagation();
    };

    useEffect(() => {
        const orderStClickOutside = (event) => {
            if (
                orderStButtonRef.current &&
                orderStButtonRef.current.contains(event.target)
            ) {
                setOrderStSelectShow(true);
            } else if (
                orderStDivRef.current &&
                !orderStDivRef.current.contains(event.target)
            ) {
                setOrderStSelectShow(false);
            }
        };
        document.addEventListener('mousedown', orderStClickOutside);
        return () => {
            document.removeEventListener('mousedown', orderStClickOutside);
        };
    }, []);

    const [memberInfo, setMemberInfo] = useState("");

    const selectMember = (() => {
        axios({
            method: 'get',
            url: '/member/modiInfo',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
        })
            .then((response) => {
                setMemberInfo(response.data[0])
            })
            .catch(() => {
                console.log("멤버조회 실패")
            })
    })

    useEffect(() => {
        if (LCAT || SSAT) {
            selectMember();
        }
    }, [LCAT, SSAT])

    // 웹소켓
    const isSubscribedRef = useRef(false);
    const {subscribe, unsubscribe, websocketConnect, isConnected, stompClient} = useWebSocket();

    useEffect(() => {
        const initializeConnection = async () => {
            if (!memberInfo.mbNum || isSubscribedRef.current) return;

            if (!stompClient && !isConnected) {
                await websocketConnect(memberInfo.mbNum);
            }
            if (isConnected && stompClient && !isSubscribedRef.current) {
                subscribe(`/user/${memberInfo.mbNum}/queue/adminOrderStUpdate`, receivedOrderStChange);
                subscribe(`/user/${memberInfo.mbNum}/queue/adminOrderDivideMerge`, receivedOrderDivideMerge);
                subscribe(`/user/${memberInfo.mbNum}/queue/adminUpdateOrder`, updateOrderList);
                isSubscribedRef.current = true;
            }
        }
        initializeConnection();

        return () => {
            if (isSubscribedRef.current) {
                unsubscribe(`/user/${memberInfo.mbNum}/queue/adminOrderStUpdate`);
                unsubscribe(`/user/${memberInfo.mbNum}/queue/adminOrderDivideMerge`);
                unsubscribe(`/user/${memberInfo.mbNum}/queue/adminUpdateOrder`);
                isSubscribedRef.current = false;
            }
        };

    }, [memberInfo.mbNum, isConnected, stompClient]);

    const [orderdtList, setOrderdtList] = useState([{}]);
    const [productsList, setProductsList] = useState([]);
    const [payinfoList, setPayinfoList] = useState([{}]);
    const [recinfoList, setRecinfoList] = useState([{}]);
    const [isLoading, setIsLoading] = useState(false);

    const selectTotalOrderList = ((date) => {
        setIsLoading(true);

        let globalDate;
        if (["1개월 전", "1 month ago", "1ヶ月前", "1个月前", "1 Bulan yang Lalu"].includes(date)) {
            globalDate = "1개월 전";
        } else if (["3개월 전", "3 months ago", "3ヶ月前", "3个月前", "3 Bulan yang Lalu"].includes(date)) {
            globalDate = "3개월 전";
        } else if (["6개월 전", "6 months ago", "6ヶ月前", "6个月前", "6 Bulan yang Lalu"].includes(date)) {
            globalDate = "6개월 전";
        } else if (["1년 전", "1 year ago", "1年前", "1年前", "1 Tahun yang Lalu"].includes(date)) {
            globalDate = "1년 전";
        } else if (["2년 전", "2 years ago", "2年前", "2年前", "2 Tahun yang Lalu"].includes(date)) {
            globalDate = "2년 전";
        } else {
            globalDate = null;
        }

        axios({
            method: 'get',
            url: '/order/selectTotalOrderList',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
            params: {
                date: globalDate,
            },
        })
            .then((response) => {
                // let sortedData = response.data.sort((a, b) => b.seqnum - a.seqnum);
                // sortedData = sortedData.slice(0, 10);
                setOrderdtList(response.data);

                const ProdList = response.data.map(order => {
                    const productMap = new Map();
                    order.productsDTO.forEach(product => {
                        if (!productMap.has(product.seqnum)) {
                            productMap.set(product.seqnum, product);
                        }
                    });
                    return Array.from(productMap.values());
                });
                setProductsList(ProdList);

                const payList = response.data.flatMap(order => order.payInfoDTO);
                setPayinfoList(payList);

                const recList = response.data.map(order => order.recinfoDTO);
                setRecinfoList(recList);

            })
            .catch(() => {
            })
            .finally(() => {
                setIsLoading(false);
            })
    })

    useEffect(() => {
        selectTotalOrderList(periodSelectCommonValue);
    }, [periodSelectCommonValue]);

    const myOrdPgMove = (ordNum) => () => {
        navigate(`/UserMyOrderPg/${ordNum}`);
    };

    const [paySeqnum, setPaySeqnum] = useState(null);
    const [payShipco, setPayShipco] = useState('');
    const [deliveryDetailSt, setDeliveryDetailSt] = useState(false);
    const deliveryDetailFalseFn = (() => {
        setDeliveryDetailSt(false);
    })
    const deliveryDetailTrueFn = ((seqNum, shipco) => {
        setPaySeqnum(seqNum);
        setPayShipco(shipco);
        setDeliveryDetailSt(true);
    })

    const updateAppRecinfo = (updatedPayinfo) => {
        setFilteredList((prevPayinfoList) => {
            return prevPayinfoList.map((payinfo) => {
                if (payinfo.appRecDTO && payinfo.appRecDTO.seqnum === updatedPayinfo.seqnum) {
                    return {...payinfo, appRecDTO: updatedPayinfo};
                }
                return payinfo;
            });
        });
    };

    const updatePayinfoList = (updatedPayinfo) => {
        setPayinfoList((prevPayinfoList) => {
            return prevPayinfoList.map((payinfo) =>
                payinfo.seqNum === updatedPayinfo.seqNum ? updatedPayinfo : payinfo,
            );
        });
    };

    const receivedOrderStChange = ((payload) => {
        let data = JSON.parse(payload.body);
        setFilteredList(prevList => {
            return prevList.map(item => {
                // 조건에 맞는 항목 찾기
                if (item.type === 'orderdt' && item.seqnum === data.orderSeqNum) {
                    // 해당 항목의 orderStatus를 data.orderSt로 업데이트
                    return {
                        ...item,
                        orderStatus: data.orderSt
                    };
                }
                // 다른 항목들은 그대로 유지
                return item;
            });
        });
    });

    const receivedOrderDivideMerge = ((payload) => {
        let data = JSON.parse(payload.body);
        selectTotalOrderList(periodSelectCommonValue);
        selectedAllProcessCount(memberInfo.mbNum)
    })

    const updateOrderList = ((payload) => {
        let data = JSON.parse(payload.body);
        selectTotalOrderList(periodSelectCommonValue);
        selectedAllProcessCount(memberInfo.mbNum)
    })

    const [searchQuery, setSearchQuery] = useState("");
    const [filteredList, setFilteredList] = useState([]);
    const [orderListDisplayLimit, setOrderListDisplayLimit] = useState(20);
    const handleMoreOrderList = () => {
        setOrderListDisplayLimit(prev => prev + 20);
    }

    const convertToShipco = ((dvType, defalutShipco) => {
        if (dvType === 'D00') {
            return '국내배송';
        } else if (dvType === 'D01') {
            return 'FedEx';
        } else if (dvType === 'D16') {
            return 'FedEx-E';
        } else if (dvType === 'D11') {
            return 'UPS';
        } else if (dvType === 'D17') {
            return 'UPS-E';
        } else if (dvType === 'D02') {
            return 'EMS';
        } else if (dvType === 'D15') {
            return 'EMSP';
        } else if (dvType === 'D04') {
            return 'DHL';
        } else if (dvType === 'D13') {
            return 'K-Packet';
        } else if (dvType === 'D14') {
            return 'Small-Packet';
        } else if (dvType === 'D03') {
            return 'SEA';
        } else {
            return defalutShipco;
        }
    });

    // useEffect(() => {
    //     const combined = [
    //         ...orderdtList.map((item) => ({
    //             type: 'orderdt',
    //             date: item.modiTime || item.regTime,
    //             mostRecentDate: new Date(Math.max(new Date(item.modiTime), new Date(item.regTime))),
    //             ...item,
    //         })),
    //         ...payinfoList.map((item) => ({
    //             type: 'payinfo',
    //             date: item?.modiTime || item?.regTime,
    //             mostRecentDate: new Date(Math.max(new Date(item.modiTime), new Date(item.regTime))),
    //             ...item,
    //         })),
    //     ];
    //
    //     combined.sort((a, b) => b.mostRecentDate - a.mostRecentDate);
    //     // combined.sort((a, b) => moment(b.date).isAfter(moment(a.date)) ? 1 : -1);
    //
    //     const filterStatus = (order) => {
    //         if (orderStSelectCommonValue === t(`state`)) return true;
    //         switch (orderStSelectCommonValue) {
    //             case "PS0":
    //                 return (order.type === 'orderdt' && order.orderStatus === "OS09") ||
    //                     (order.type === 'payinfo' && order.payStatus === "PS0");
    //             case "PS1":
    //                 return (order.type === 'orderdt' && order.orderStatus === "OS10") ||
    //                     (order.type === 'payinfo' && order.payStatus === "PS1");
    //             case "PS2":
    //                 return (order.type === 'orderdt' && order.orderStatus === "OS11") ||
    //                     (order.type === 'payinfo' && order.payStatus === "PS2");
    //             case "PS3":
    //                 return (order.type === 'orderdt' && order.orderStatus === "OS12") ||
    //                     (order.type === 'payinfo' && order.payStatus === "PS3");
    //             case "PS4":
    //                 return (order.type === 'orderdt' && order.orderStatus === "OS13") ||
    //                     (order.type === 'payinfo' && order.payStatus === "PS4");
    //             case "PS5":
    //                 return (order.type === 'orderdt' && order.orderStatus === "OS14") ||
    //                     (order.type === 'payinfo' && order.payStatus === "PS5");
    //             default:
    //                 return (order.type === 'orderdt' && order.orderStatus === orderStSelectCommonValue) ||
    //                     (order.type === 'payinfo' && order.payStatus === orderStSelectCommonValue);
    //         }
    //     }
    //
    //     const filterOrderType = (order) => {
    //         if (orderTypeSelectCommonValue === t('orderType')) {
    //             return true;  // 모든데이터
    //         }
    //         if (orderTypeSelectCommonValue === t('myTab1')) {
    //             return order.type === 'orderdt';
    //         }
    //         if (orderTypeSelectCommonValue === t('deliveryOption')) {
    //             return order.type === 'payinfo';
    //         }
    //         return true;
    //     };
    //
    //     const newList = combined.filter((order) => {
    //         if (!filterStatus(order)) return false;
    //         if (!filterOrderType(order)) return false;
    //         if (searchQuery === "") return true;
    //
    //         if (order.type === 'orderdt') {
    //             return (
    //                 (order.shipco && order.shipco.toLowerCase().includes(searchQuery)) ||
    //                 (order.recinfoDTO.recname && order.recinfoDTO.recname.toLowerCase().includes(searchQuery)) ||
    //                 (order.recinfoDTO.countryDTO && order.recinfoDTO.countryDTO.countryEngNm.toLowerCase().includes(searchQuery)) ||
    //                 (order.productsDTO && order.productsDTO.some((prod) => prod.name && prod.name.toLowerCase().includes(searchQuery))) ||
    //                 (order.orderNumber && order.orderNumber.toLowerCase().includes(searchQuery))
    //             );
    //         }
    //         if (order.type === 'payinfo') {
    //             return (
    //                 (order && convertToShipco(order.dvType, order.orderdtDTO?.shipco).toLowerCase().includes(searchQuery)) ||
    //                 (order.appRecDTO && order.appRecDTO.countryDTO && order.appRecDTO.countryDTO.countryEngNm.toLowerCase().includes(searchQuery)) ||
    //                 (order.appRecDTO && order.appRecDTO.recname && order.appRecDTO.recname.toLowerCase().includes(searchQuery)) ||
    //                 (order.packListDTO && order.packListDTO.productsDTO && order.packListDTO.productsDTO.some((prod) => prod.name && prod.name.toLowerCase().includes(searchQuery))) ||
    //                 (order.orderdtDTO?.orderNumber && order.orderdtDTO?.orderNumber.toLowerCase().includes(searchQuery))
    //             );
    //         }
    //     });
    //     setFilteredList(newList);
    // }, [orderdtList, payinfoList, searchQuery, orderStSelectCommonValue, orderTypeSelectCommonValue]);
    //
    // useEffect(() => {
    //     if (memberInfo.mbNum)
    //         selectedAllProcessCount(memberInfo.mbNum)
    // }, [memberInfo])

    // [복구] 리뉴얼 중 위 useEffect 가 주석 처리되어, 초기 로드 시 주문현황 count(주문절차/해외배송/반송)가
    // 조회되지 않아 전부 0 으로 표시되던 문제 → 앱(MyPg.js)의 useEffect([memberInfo]) 와 동일하게 복구.
    useEffect(() => {
        if (memberInfo.mbNum) {
            selectedAllProcessCount(memberInfo.mbNum);
        }
    }, [memberInfo]);


    useEffect(() => {
        // 검색어 소문자 변환 및 양끝 공백 제거
        const query = searchQuery.trim().toLowerCase();

        // 안전한 타임스탬프 추출 함수 (Invalid Date 방지)
        const getTimestamp = (dateStr) => {
            if (!dateStr) return 0;
            const time = new Date(dateStr).getTime();
            return isNaN(time) ? 0 : time;
        };

        const combined = [
            ...orderdtList.map((item) => ({
                type: 'orderdt',
                date: item.modiTime || item.regTime,
                mostRecentTime: Math.max(getTimestamp(item.modiTime), getTimestamp(item.regTime)),
                ...item,
            })),
            ...payinfoList.map((item) => ({
                type: 'payinfo',
                date: item?.modiTime || item?.regTime,
                mostRecentTime: Math.max(getTimestamp(item?.modiTime), getTimestamp(item?.regTime)),
                ...item,
            })),
        ];

        combined.sort((a, b) => b.mostRecentTime - a.mostRecentTime);

        const filterStatus = (order) => {
            if (orderStSelectCommonValue === t(`state`)) return true;
            switch (orderStSelectCommonValue) {
                case "PS0":
                    return (order.type === 'orderdt' && order.orderStatus === "OS09") ||
                        (order.type === 'payinfo' && order.payStatus === "PS0");
                case "PS1":
                    return (order.type === 'orderdt' && order.orderStatus === "OS10") ||
                        (order.type === 'payinfo' && order.payStatus === "PS1");
                case "PS2":
                    return (order.type === 'orderdt' && order.orderStatus === "OS11") ||
                        (order.type === 'payinfo' && order.payStatus === "PS2");
                case "PS3":
                    return (order.type === 'orderdt' && order.orderStatus === "OS12") ||
                        (order.type === 'payinfo' && order.payStatus === "PS3");
                case "PS4":
                    return (order.type === 'orderdt' && order.orderStatus === "OS13") ||
                        (order.type === 'payinfo' && order.payStatus === "PS4");
                case "PS5":
                    return (order.type === 'orderdt' && order.orderStatus === "OS14") ||
                        (order.type === 'payinfo' && order.payStatus === "PS5");
                default:
                    return (order.type === 'orderdt' && order.orderStatus === orderStSelectCommonValue) ||
                        (order.type === 'payinfo' && order.payStatus === orderStSelectCommonValue);
            }
        };

        const filterOrderType = (order) => {
            if (orderTypeSelectCommonValue === t('orderType')) return true;
            if (orderTypeSelectCommonValue === t('myTab1')) return order.type === 'orderdt';
            if (orderTypeSelectCommonValue === t('deliveryOption')) return order.type === 'payinfo';
            return true;
        };

        const newList = combined.filter((order) => {
            if (!filterStatus(order)) return false;
            if (!filterOrderType(order)) return false;
            if (!query) return true; // 검색어가 빈 문자열이면 전체 반환

            // 옵셔널 체이닝(?.) 적용 및 query(소문자) 비교
            if (order.type === 'orderdt') {
                return (
                    (order.username && order.username.toLowerCase().includes(query)) ||
                    (order.shipco && order.shipco.toLowerCase().includes(query)) ||
                    (order.recinfoDTO?.recname && order.recinfoDTO.recname.toLowerCase().includes(query)) ||
                    (order.recinfoDTO?.countryDTO?.countryEngNm && order.recinfoDTO.countryDTO.countryEngNm.toLowerCase().includes(query)) ||
                    (order.productsDTO && order.productsDTO.some((prod) => prod.name?.toLowerCase().includes(query))) ||
                    (order.orderNumber && order.orderNumber.toLowerCase().includes(query))
                );
            }
            if (order.type === 'payinfo') {
                return (
                    (order.username && order.username.toLowerCase().includes(query)) ||
                    (convertToShipco(order.dvType, order.orderdtDTO?.shipco)?.toLowerCase().includes(query)) ||
                    (order.appRecDTO?.countryDTO?.countryEngNm && order.appRecDTO.countryDTO.countryEngNm.toLowerCase().includes(query)) ||
                    (order.appRecDTO?.recname && order.appRecDTO.recname.toLowerCase().includes(query)) ||
                    (order.packListDTO?.productsDTO && order.packListDTO.productsDTO.some((prod) => prod.name?.toLowerCase().includes(query))) ||
                    (order.orderdtDTO?.orderNumber && order.orderdtDTO.orderNumber.toLowerCase().includes(query))
                );
            }
            return false;
        });

        setFilteredList(newList);
    }, [orderdtList, payinfoList, searchQuery, orderStSelectCommonValue, orderTypeSelectCommonValue]);



    const [processData, setProcessData] = useState([]);
    const selectedAllProcessCount = ((mbNum) => {
        axios({
            method: 'get',
            url: '/order/selectedAllProcessCount',
            params: {
                mbNum: mbNum
            }
        })
            .then((response) => {
                setProcessData(response.data);
            })
            .catch((error) => {
                console.log("프로세스수량 조회실패 : ", error)
            })
    })

    const selectNoDateTotalOrderList = ((orderSt) => {
        axios({
            method: 'get',
            url: '/order/selectTotalOrderList',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
        })
            .then((response) => {
                // let sortedData = response.data.sort((a, b) => b.seqnum - a.seqnum);
                // sortedData = sortedData.slice(0, 10);
                setOrderdtList(response.data);
                const ProdList = response.data.map(order => {
                    const productMap = new Map();
                    order.productsDTO.forEach(product => {
                        if (!productMap.has(product.seqnum)) {
                            productMap.set(product.seqnum, product);
                        }
                    });
                    return Array.from(productMap.values());
                });
                setProductsList(ProdList);

                const payList = response.data.flatMap(order => order.payInfoDTO);
                setPayinfoList(payList);

                const recList = response.data.map(order => order.recinfoDTO);
                setRecinfoList(recList);

                orderStBtHandle(orderSt);
                setPeriodSelectCommonValue(t('all'))

            })
            .catch((error) => {
                console.log("노데이트 주문조회실패 : ", error)
            })
    })

    const [payPeriodSelectShow, setPayPeriodSelectShow] = useState(false);
    const [payPeriodSelectCommonValue, setPayPeriodSelectCommonValue] = useState(t(`myPrd1`));
    const payPeriodButtonRef = useRef(null);
    const payPeriodDivRef = useRef(null);

    const payPeriodBtHandle = (newValue) => {
        setPayPeriodSelectShow(false);
        setPayPeriodSelectCommonValue(newValue);
    };
    const payPeriodDivHandle = (event) => {
        event.stopPropagation();
    };

    useEffect(() => {
        const payPeriodClickOutside = (event) => {
            if (
                payPeriodButtonRef.current &&
                payPeriodButtonRef.current.contains(event.target)
            ) {
                // Clicked on the duration button
                setPayPeriodSelectShow(true);
            } else if (
                payPeriodDivRef.current &&
                !payPeriodDivRef.current.contains(event.target)
            ) {
                // Clicked outside the div
                setPayPeriodSelectShow(false);
            }
        };
        document.addEventListener('mousedown', payPeriodClickOutside);
        return () => {
            document.removeEventListener('mousedown', payPeriodClickOutside);
        };
    }, []);

    const filterOrderSt = (status) => {

        let viewStatus;
        switch (status) {
            case t(`state`):
                viewStatus = t(`state`);
                break;
            case "OS00":
                viewStatus = t(`prodStLabel1`);
                break;
            case "OS01":
                viewStatus = t(`prodStLabel2`);
                break;
            case "OS02":
                viewStatus = t(`prodStLabel3`);
                break;
            case "OS03":
                viewStatus = t(`prodStLabel4`);
                break;
            case "OS04":
                viewStatus = t(`prodStLabel14`);
                break;
            case "OS05":
                viewStatus = t(`prodStLabel5`);
                break;
            case "OS06":
                viewStatus = t(`prodStLabel15`);
                break;
            case "OS07":
                viewStatus = t(`prodStLabel6`);
                break;
            case "OS08":
                viewStatus = t(`prodStLabel7`);
                break;
            case "PS0":
                viewStatus = t(`prodStLabel8`);
                break;
            case "PS1":
                viewStatus = t(`prodStLabel9`);
                break;
            case "PS2":
                viewStatus = t(`prodStLabel10`);
                break;
            case "PS3":
                viewStatus = t(`prodStLabel11`);
                break;
            case "PS4":
                viewStatus = t(`prodStLabel12`);
                break;
            case "PS5":
                viewStatus = t(`prodStLabel13`);
                break;
        }
        return viewStatus;
    };

    const [payList, setPayList] = useState([]);
    const payHistoryList = ((dateParam) => {

        let globalDate;
        if (["1개월 전", "1 month ago", "1ヶ月前", "1个月前", "1 Bulan yang Lalu"].includes(dateParam)) {
            globalDate = "1개월 전";
        } else if (["3개월 전", "3 months ago", "3ヶ月前", "3个月前", "3 Bulan yang Lalu"].includes(dateParam)) {
            globalDate = "3개월 전";
        } else if (["6개월 전", "6 months ago", "6ヶ月前", "6个月前", "6 Bulan yang Lalu"].includes(dateParam)) {
            globalDate = "6개월 전";
        } else if (["1년 전", "1 year ago", "1年前", "1年前", "1 Tahun yang Lalu"].includes(dateParam)) {
            globalDate = "1년 전";
        } else if (["2년 전", "2 years ago", "2年前", "2年前", "2 Tahun yang Lalu"].includes(dateParam)) {
            globalDate = "2년 전";
        } else {
            globalDate = null;
        }

        axios({
            method: 'get',
            url: '/order/payHistoryList',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
            params: {
                date: globalDate,
            },
        })
            .then((response) => {
                // payType이 통합결제이거나 자식이 아닌 단독결제건(상품금액/해외배송료/기타비용)만 출력
                const filteredData = response.data.filter(data => data.payType === 'PT3' || !data.childFl);
                setPayList(filteredData);
            })
            .catch(() => {
                console.log("실패")
            })
    })

    const sortedPayList = payList.sort((a, b) => b.seqNum - a.seqNum);
    const [payListDisplayLimit, setPayListDisplayLimit] = useState(20);
    const handleMorePayList = () => {
        setPayListDisplayLimit(prev => prev + 20);
    }

    const [payStSelectShow, setPayStSelectShow] = useState(false);
    const [payStSelectCommonValue, setPayStSelectCommonValue] = useState(t(`state`));
    const payStButtonRef = useRef(null);
    const payStDivRef = useRef(null);

    const payStBtHandle = (newValue) => {
        setPayStSelectShow(false);
        setPayStSelectCommonValue(newValue);
        filterPaySt(newValue);
    };

    useEffect(() => {
        payHistoryList(payPeriodSelectCommonValue);
    }, [payPeriodSelectCommonValue]);

    const payStDivHandle = (event) => {
        event.stopPropagation();
    };

    useEffect(() => {
        const payStClickOutside = (event) => {
            if (
                payStButtonRef.current &&
                payStButtonRef.current.contains(event.target)
            ) {
                setPayStSelectShow(true);
            } else if (
                payStDivRef.current &&
                !payStDivRef.current.contains(event.target)
            ) {
                setPayStSelectShow(false);
            }
        };
        document.addEventListener('mousedown', payStClickOutside);
        return () => {
            document.removeEventListener('mousedown', payStClickOutside);
        };
    }, []);

    const filterStatus = (pay) => {
        if (payStSelectCommonValue === t(`state`)) return true;
        return pay.payStatus === payStSelectCommonValue;
    }

    const filterPaySt = (status) => {
        let viewStatus;
        switch (status) {
            case t(`state`):
                viewStatus = t(`state`)
                break;
            case "PS0":
                viewStatus = t(`prodStLabel8`)
                break;
            case "PS1":
                viewStatus = t(`prodStLabel9`)
                break;
            case "PS2":
                viewStatus = t(`prodStLabel10`)
                break;
        }
        return viewStatus;
    };

    const [dacPeriodSelectShow, setDacPeriodSelectShow] = useState(false);
    const [dacPeriodSelectCommonValue, setDacPeriodSelectCommonValue] = useState(t(`myPrd1`));
    const dacPeriodButtonRef = useRef(null);
    const dacPeriodDivRef = useRef(null);

    const dacPeriodBtHandle = (newValue) => {
        setDacPeriodSelectShow(false);
        setDacPeriodSelectCommonValue(newValue);
        dacHistoryList(newValue);
    };
    const dacPeriodDivHandle = (event) => {
        event.stopPropagation();
    };

    useEffect(() => {
        const dacPeriodClickOutside = (event) => {
            if (
                dacPeriodButtonRef.current &&
                dacPeriodButtonRef.current.contains(event.target)
            ) {
                // Clicked on the duration button
                setDacPeriodSelectShow(true);
            } else if (
                dacPeriodDivRef.current &&
                !dacPeriodDivRef.current.contains(event.target)
            ) {
                // Clicked outside the div
                setDacPeriodSelectShow(false);
            }
        };
        document.addEventListener('mousedown', dacPeriodClickOutside);
        return () => {
            document.removeEventListener('mousedown', dacPeriodClickOutside);
        };
    }, []);

    const [dacList, setDacList] = useState([]);
    const dacHistoryList = ((dateParam) => {

        let globalDate;
        if (["1개월 전", "1 month ago", "1ヶ月前", "1个月前", "1 Bulan yang Lalu"].includes(dateParam)) {
            globalDate = "1개월 전";
        } else if (["3개월 전", "3 months ago", "3ヶ月前", "3个月前", "3 Bulan yang Lalu"].includes(dateParam)) {
            globalDate = "3개월 전";
        } else if (["6개월 전", "6 months ago", "6ヶ月前", "6个月前", "6 Bulan yang Lalu"].includes(dateParam)) {
            globalDate = "6개월 전";
        } else if (["1년 전", "1 year ago", "1年前", "1年前", "1 Tahun yang Lalu"].includes(dateParam)) {
            globalDate = "1년 전";
        } else if (["2년 전", "2 years ago", "2年前", "2年前", "2 Tahun yang Lalu"].includes(dateParam)) {
            globalDate = "2년 전";
        } else {
            globalDate = null;
        }

        axios({
            method: 'get',
            url: '/order/dacHistoryList',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
            params: {
                date: globalDate
            },
        })
            .then((response) => {
                setDacList(response.data)
                // console.log("예적쿠 리스트 : ", response.data)
            })
            .catch(() => {
                console.log("실패")
            })
    })

    useEffect(() => {
        dacHistoryList(dacPeriodSelectCommonValue);
    }, [dacPeriodSelectCommonValue]);

    const formatDate = (dateString) => {
        if (!dateString) {
            return "";
        }
        return `${dateString.substring(0, 4)}-${dateString.substring(4, 6)}-${dateString.substring(6, 8)}`;
    };

    const sortedDacList = dacList.sort((a, b) => b.seqNum - a.seqNum);
    const initialLimit = 10;

    const [dacDisplayLimits, setDacDisplayLimits] = useState({
        deposit: initialLimit,
        point: initialLimit,
        coupon: initialLimit,
    });

    const handleMoreDacList = (type) => {
        setDacDisplayLimits(prevLimits => ({
            ...prevLimits,
            [type]: prevLimits[type] + 10
        }));
    };

    const [selectedRows, setSelectedRows] = useState([]);

    const [selectAll, setSelectAll] = useState(false);
    const handleCheckboxChange = (orderId) => {
        setSelectedRows(prevRows => {
            if (prevRows.includes(orderId)) {
                return prevRows.filter(row => row !== orderId);
            } else {
                return [...prevRows, orderId];
            }
        });
    };

    const handleSelectAllChange = () => {
        if (selectAll) {
            setSelectedRows([]);
        } else {
            setSelectedRows(
                filteredList.map(order => {
                    if (order.type === 'orderdt') {
                        return order.seqnum;
                    } else if (order.type === 'payinfo' && (order.payType === "PT1")) {
                        return order.seqNum;
                    }
                    return null;
                }).filter(seqNum => seqNum !== null)
            );
        }
        setSelectAll(!selectAll);
    };

    const [downNoSelectSt, setDownNoSelectSt] = useState(false);
    const closeDownNoSelect = (() => {
        setDownNoSelectSt(false);
    })

    const date = new Date();
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const DateViewValue = year + month + day;

    const [nonSelectedShow, setNonSelectedShow] = useState(false);
    const closeNonSelectedShow = () => {
        setNonSelectedShow(false);
    }

    const invoiceDown = async () => {
        try {
            const allData = [...filteredList];
            const selectedRowData = allData.filter((item) => selectedRows.includes(item.seqnum || item.seqNum));
            console.log("다운된 데이터 : ", selectedRowData)

            if (selectedRowData.length === 0) {
                setNonSelectedShow(true);
                return;
            }

            const excel = require('exceljs');

            for (let i = 0; i < selectedRowData.length; i++) {
                const rowData = selectedRowData[i];
                const workbook = new excel.Workbook();
                // console.log('rowData:', rowData);
                workbook.created = new Date();
                workbook.modified = new Date();

                const worksheet = workbook.addWorksheet('Invoice');

                //region dataSet

                let userName = '';

                if (rowData.type === 'orderdt') {
                    userName = rowData.memberDTO.userName || '';
                } else if (rowData.type === 'payinfo') {
                    userName = rowData.orderdtDTO.memberDTO.userName || '';
                } else {
                    userName = '';
                }

                let orderNo = '';

                if (rowData.type === 'orderdt') {
                    orderNo = rowData.orderNumber || '';
                } else if (rowData.type === 'payinfo') {
                    const orderNumber = rowData.orderdtDTO?.orderNumber || '';
                    const boxNum = rowData.shipInfoDTO?.boxNum || '0';
                    orderNo = `${orderNumber}-${boxNum}`;
                } else {
                    orderNo = '';
                }

                // endregion

                // region 열너비 & 행높이

                //열너비
                worksheet.getColumn('A').width = 0.8;
                worksheet.getColumn('B').width = 13;
                worksheet.getColumn('C').width = 13;
                worksheet.getColumn('D').width = 13;
                worksheet.getColumn('E').width = 25;
                worksheet.getColumn('F').width = 23;
                worksheet.getColumn('G').width = 11;
                worksheet.getColumn('H').width = 15;
                worksheet.getColumn('I').width = 15;

                //행높이
                worksheet.getRow(1).height = 4;
                worksheet.getRow(2).height = 29;
                worksheet.getRow(3).height = 4;
                worksheet.getRow(4).height = 29;
                worksheet.getRow(5).height = 4;

                for (let row = 6; row <= 13; row++) {
                    worksheet.getRow(row).height = 18;
                }
                worksheet.getRow(11).height = 10;
                worksheet.getRow(20).height = 4;
                worksheet.getRow(21).height = 32;
                for (let row = 22; row <= 56; row++) {
                    worksheet.getRow(row).height = 18;
                }
                worksheet.getRow(57).height = 20;

                // endregion

                // region 엑셀내용

                const thinBorder = { style: 'thin' };

                worksheet.mergeCells('B2:I2');
                const titleCell = worksheet.getCell('B2');
                titleCell.value = 'INVOICE';
                titleCell.alignment = { vertical: 'middle', horizontal: 'center' };
                titleCell.font = { name: 'Arial', size: 18, bold: true };
                const borderStyle = { style: 'medium' };
                worksheet.getCell('B2').border = {
                    top: borderStyle,
                    bottom: borderStyle,
                };

                worksheet.mergeCells('B4:C4');
                const lcWaybillCell = worksheet.getCell('B4');
                lcWaybillCell.value = 'L/C No. and Waybill No.';
                lcWaybillCell.alignment = { vertical: 'middle', horizontal: 'right' };
                lcWaybillCell.font = { name: 'Arial', size: 12, bold: true };

                console.log("rowData : ", rowData)

                worksheet.mergeCells('D4:E4');
                const waybillValueCell = worksheet.getCell('D4');
                if (rowData.type === 'payinfo') {
                    waybillValueCell.value = rowData.shipInfoDTO.outWayNum;
                } else {
                    waybillValueCell.value = '';
                }
                waybillValueCell.alignment = { vertical: 'middle', horizontal: 'center' };
                waybillValueCell.font = { name: 'Arial', size: 13, bold: true, italic: true };

                worksheet.mergeCells('F4:H4');
                const exportDateTitleCell = worksheet.getCell('F4');
                exportDateTitleCell.value = 'Date of Exportation.';
                exportDateTitleCell.alignment = { vertical: 'middle', horizontal: 'right' };
                exportDateTitleCell.font = { name: 'Arial', size: 12, bold: true };

                const today = new Date();
                const monthShort = today.toLocaleString('en-US', { month: 'short' }); // 예: Sep
                const day = String(today.getDate()).padStart(2, '0');                 // 예: 06
                const year = today.getFullYear();                                     // 예: 2025
                const formattedToday = `${monthShort}-${day}-${year}`;               // 예: Sep-06-2025
                const exportDateValueCell = worksheet.getCell('I4');
                exportDateValueCell.value = formattedToday;
                exportDateValueCell.alignment = {vertical: 'middle', horizontal: 'center'};
                exportDateValueCell.font = {name: 'Arial', size: 12, bold: true};

                worksheet.mergeCells('B6:E6');
                const shipperCell = worksheet.getCell('B6');
                shipperCell.value = 'Shipper / Exporter';
                shipperCell.alignment = { vertical: 'middle', horizontal: 'center' };
                shipperCell.font = { name: 'Arial', size: 12, bold: true };

                worksheet.mergeCells('F6:I6');
                const consigneeCell = worksheet.getCell('F6');
                consigneeCell.value = 'Consignee';
                consigneeCell.alignment = { vertical: 'middle', horizontal: 'center' };
                consigneeCell.font = { name: 'Arial', size: 12, bold: true };

                for (let row = 7; row <= 13; row++) {
                    worksheet.mergeCells(`B${row}:E${row}`);
                }

                for (let row = 7; row <= 19; row++) {
                    worksheet.getCell(`F${row}`).border = {
                        left: thinBorder,
                    };
                }

                worksheet.getCell('E6').border = {right: thinBorder,};

                for (let col of ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']) {
                    worksheet.getCell(`${col}5`).border = { bottom: thinBorder};
                    worksheet.getCell(`${col}14`).border = { top: thinBorder};
                    worksheet.getCell(`${col}57`).border = { top: thinBorder, bottom: thinBorder};
                }

                const skyBlue = { argb: 'FFE5EEFF' };
                const lightGray = { argb: 'FFF0F0F0' };

                for (let col of ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']) {
                    worksheet.getCell(`${col}6`).fill = { type: 'pattern', pattern: 'solid', fgColor: skyBlue };
                }

                for (let row = 14; row <= 19; row++) {
                    for (let col of ['B', 'C', 'D']) {
                        worksheet.getCell(`${col}${row}`).fill = { type: 'pattern', pattern: 'solid', fgColor: skyBlue };
                    }
                }

                for (let col of ['F', 'G', 'H', 'I']) {
                    worksheet.getCell(`${col}14`).fill = { type: 'pattern', pattern: 'solid', fgColor: skyBlue };
                }

                for (let col of ['B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']) {
                    worksheet.getCell(`${col}21`).fill = { type: 'pattern', pattern: 'solid', fgColor: lightGray };
                }

                // region 발송인

                worksheet.getCell('B7').value = 'IMEUNWOO(individual)';
                worksheet.getCell('B7').alignment = { vertical: 'middle', horizontal: 'left' };
                worksheet.getCell('B7').font = { name: 'Arial', size: 11 };

                worksheet.getCell('B8').value = '32-15, Yeongok-gil 42beon-gil, Gonjiam-eup,';
                worksheet.getCell('B8').alignment = { vertical: 'middle', horizontal: 'left' };
                worksheet.getCell('B8').font = { name: 'Arial', size: 11 };

                worksheet.getCell('B9').value = 'Gwangji-si, Gyeonggi-do (zipcode 12722)';
                worksheet.getCell('B9').alignment = { vertical: 'middle', horizontal: 'left' };
                worksheet.getCell('B9').font = { name: 'Arial', size: 11 };

                worksheet.getCell('B10').value = 'Tel: 82-10-3338-9354';
                worksheet.getCell('B10').alignment = { vertical: 'middle', horizontal: 'left' };
                worksheet.getCell('B10').font = { name: 'Arial', size: 11 };

                worksheet.getCell('B12').value = '(empty)';
                worksheet.getCell('B12').alignment = { vertical: 'middle', horizontal: 'left' };
                worksheet.getCell('B12').font = { name: 'Arial', size: 11 };

                worksheet.getCell('B13').value = '(empty)';
                worksheet.getCell('B13').alignment = { vertical: 'middle', horizontal: 'left' };
                worksheet.getCell('B13').font = { name: 'Arial', size: 11 };

                // endregion

                // region 수취인

                const receiver = rowData.type === 'payinfo'
                    ? rowData.appRecDTO
                    : rowData.recinfoDTO;

                const fullAddress =
                    (receiver?.address1 || '') +
                    (receiver?.address2 || '') +
                    (receiver?.address3 || '');

                const cityZipcode =
                    (receiver?.city || '') +
                    ' (zipcode ' + (receiver?.zipcode || '') + ')';

                worksheet.mergeCells('F7:I13');
                const mergedCell = worksheet.getCell('F7');

                mergedCell.value =
                    (receiver?.recname || '') + '\n' +
                    fullAddress + '\n' +
                    cityZipcode + '\n\n' +
                    'Tel: ' + (receiver?.telnum || '');

                mergedCell.alignment = { vertical: 'top', horizontal: 'left', wrapText: true };
                mergedCell.font = { name: 'Arial', size: 11 };

                //수취인과 다를경우 직접입력
                worksheet.mergeCells('F15:I19');
                const mergedBuyerCell = worksheet.getCell('F15');
                mergedBuyerCell.value = '';
                mergedBuyerCell.alignment = { vertical: 'middle', horizontal: 'left' };
                mergedBuyerCell.font = { name: 'Arial', size: 11 };

                // endregion

                // region 기타정보

                worksheet.mergeCells('B14:D15');
                const countryExportCell = worksheet.getCell('B14');
                countryExportCell.value = 'Country of Export';
                countryExportCell.alignment = { vertical: 'middle', horizontal: 'center' };
                countryExportCell.font = { name: 'Arial', size: 11, bold: true };
                countryExportCell.border = { top: thinBorder };

                worksheet.mergeCells('F14:I14');
                const buyerCell = worksheet.getCell('F14');
                buyerCell.value = 'Buyer (if other than consignee)';
                buyerCell.alignment = { vertical: 'middle', horizontal: 'center' };
                buyerCell.font = { name: 'Arial', size: 11, bold: true };

                worksheet.mergeCells('B16:D17');
                const reasonExportCell = worksheet.getCell('B16');
                reasonExportCell.value = 'Reason for Export';
                reasonExportCell.alignment = { vertical: 'middle', horizontal: 'center' };
                reasonExportCell.font = { name: 'Arial', size: 11, bold: true };
                reasonExportCell.border = { bottom: thinBorder, top: thinBorder };

                worksheet.mergeCells('E14:E15');
                const koreaCell = worksheet.getCell('E14');
                koreaCell.value = 'Republic of Korea [KR]';
                koreaCell.alignment = { vertical: 'middle', horizontal: 'center' };
                koreaCell.font = { name: 'Arial', size: 11 };
                koreaCell.border = { bottom: thinBorder };
                koreaCell.border = { top: thinBorder };

                worksheet.mergeCells('E16:E17');
                const giftCell = worksheet.getCell('E16');
                giftCell.value = 'e.g.personal gift';
                giftCell.alignment = { vertical: 'middle', horizontal: 'center' };
                giftCell.font = { name: 'Arial', size: 11 };
                giftCell.border = { bottom: thinBorder, top: thinBorder };

                worksheet.mergeCells('B18:D19');
                const destinationTitleCell = worksheet.getCell('B18');
                destinationTitleCell.value = 'Country of Ultimate Destination';
                destinationTitleCell.alignment = { vertical: 'middle', horizontal: 'center' };
                destinationTitleCell.font = { name: 'Arial', size: 11, bold: true };

                worksheet.mergeCells('E18:E19');
                const destinationCountryCell = worksheet.getCell('E18');
                let destinationCountry = '';
                if (rowData.type === 'orderdt') {
                    destinationCountry =
                        (rowData.recinfoDTO.countryDTO.countryEngNm || '') +
                        ' [' + (rowData.recinfoDTO.countryDTO.countryCode || '') + ']';
                } else if (rowData.type === 'payinfo') {
                    destinationCountry =
                        (rowData.appRecDTO.countryDTO.countryEngNm || '') +
                        ' [' + (rowData.appRecDTO.countryDTO.countryCode || '') + ']';
                }
                destinationCountryCell.value = destinationCountry;
                destinationCountryCell.alignment = { vertical: 'middle', horizontal: 'center' };
                destinationCountryCell.font = { name: 'Arial', size: 10 };

                // endregion

                worksheet.mergeCells('B20:I20');
                const GbnCell = worksheet.getCell('B20');
                GbnCell.border = { bottom: thinBorder, top: thinBorder };

                worksheet.getCell('B21').value = 'Country of Origin';
                worksheet.getCell('B21').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                worksheet.getCell('B21').font = { name: 'Arial', size: 11, bold: true };

                worksheet.getCell('C21').value = 'Pkgs / Type';
                worksheet.getCell('C21').alignment = { vertical: 'middle', horizontal: 'center' };
                worksheet.getCell('C21').font = { name: 'Arial', size: 11, bold: true };

                worksheet.mergeCells('D21:F21');
                worksheet.getCell('D21').value = 'Description of Goods';
                worksheet.getCell('D21').alignment = { vertical: 'middle', horizontal: 'center' };
                worksheet.getCell('D21').font = { name: 'Arial', size: 11, bold: true };

                worksheet.getCell('G21').value = 'Qty / Unit';
                worksheet.getCell('G21').alignment = { vertical: 'middle', horizontal: 'center' };
                worksheet.getCell('G21').font = { name: 'Arial', size: 11, bold: true };

                worksheet.getCell('H21').value = 'Qty / Unit Price(USD)';
                worksheet.getCell('H21').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                worksheet.getCell('H21').font = { name: 'Arial', size: 11, bold: true };

                worksheet.getCell('I21').value = 'Total Amount(USD)';
                worksheet.getCell('I21').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                worksheet.getCell('I21').font = { name: 'Arial', size: 11, bold: true };

                for (let row = 22; row <= 56; row++) {
                    worksheet.mergeCells(`D${row}:F${row}`);
                }

                for (let row = 21; row <= 56; row++) {
                    for (let col of ['B', 'C', 'D', 'G', 'H']) {
                        worksheet.getCell(`${col}${row}`).border = {
                            right: thinBorder,
                        };
                    }
                }

                worksheet.getCell('B22').value = 'KR';
                worksheet.getCell('B22').alignment = { vertical: 'middle', horizontal: 'center' };
                worksheet.getCell('B22').font = { name: 'Arial', size: 11, bold: true };

                worksheet.getCell('C22').value = '1 / cartons';
                worksheet.getCell('C22').alignment = { vertical: 'middle', horizontal: 'center' };
                worksheet.getCell('C22').font = { name: 'Arial', size: 11, bold: true };

                const startRow = 22;
                const KRW_TO_USD = 1400;
                let products = [];

                if (rowData.type === 'orderdt') {
                    products = rowData.productsDTO || [];
                } else if (rowData.type === 'payinfo') {
                    products = (rowData.packListDTO && rowData.packListDTO.productsDTO) || [];
                }

                products.forEach((product, index) => {
                    const row = startRow + index;

                    const quantity = product.quantity || 0;
                    const priceKRW = product.price || 0;
                    const totalKRW = quantity * priceKRW;

                    const priceUSD = priceKRW / KRW_TO_USD;
                    const totalUSD = totalKRW / KRW_TO_USD;

                    if (row > 56) return;

                    worksheet.getCell(`D${row}`).value = product.name || '';
                    worksheet.getCell(`D${row}`).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                    worksheet.getCell(`D${row}`).font = { name: 'Arial', size: 11 };

                    worksheet.getCell(`G${row}`).value = (product.quantity || 0).toLocaleString();
                    worksheet.getCell(`G${row}`).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                    worksheet.getCell(`G${row}`).font = { name: 'Arial', size: 11 };

                    worksheet.getCell(`H${row}`).value = priceUSD;
                    worksheet.getCell(`H${row}`).alignment = { vertical: 'middle', horizontal: 'right', wrapText: true };
                    worksheet.getCell(`H${row}`).font = { name: 'Arial', size: 11 };
                    worksheet.getCell(`H${row}`).numFmt = '"$"#,##0.00';

                    worksheet.getCell(`I${row}`).value = totalUSD;
                    worksheet.getCell(`I${row}`).alignment = { vertical: 'middle', horizontal: 'right', wrapText: true };
                    worksheet.getCell(`I${row}`).font = { name: 'Arial', size: 11 };
                    worksheet.getCell(`I${row}`).numFmt = '"$"#,##0.00';
                });

                const totalQty = products.reduce((sum, product) => {
                    return sum + (product.quantity || 0);
                }, 0);

                worksheet.getCell('G57').value = `${totalQty} EA`;
                worksheet.getCell('G57').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                worksheet.getCell('G57').font = { name: 'Arial', size: 12, bold: true };

                worksheet.getCell('I57').value = { formula: 'SUM(I22:I56)' };
                worksheet.getCell('I57').alignment = { vertical: 'middle', horizontal: 'right', wrapText: true };
                worksheet.getCell('I57').font = { name: 'Arial', size: 12, bold: true };
                worksheet.getCell('I57').numFmt = '"$"#,##0.00';

                const totalCell = worksheet.getCell('F57');
                totalCell.value = 'Total';
                totalCell.alignment = { vertical: 'middle', horizontal: 'right' };
                totalCell.font = { name: 'Arial', size: 12, bold: true };

                worksheet.mergeCells('F60:F61');

                const signedByCell = worksheet.getCell('F60');
                signedByCell.value = 'Signed By.';
                signedByCell.alignment = {vertical: 'bottom', horizontal: 'right'};
                signedByCell.font = {name: 'Arial', size: 11};
                // ✅ I61
                const signatureNameCell = worksheet.getCell('I61');
                signatureNameCell.value = 'IMEUNWOO';
                signatureNameCell.alignment = {vertical: 'bottom', horizontal: 'center'};
                signatureNameCell.font = {name: 'Arial', size: 12, bold: true};

                for (let col of ['G', 'H', 'I']) {
                    worksheet.getCell(`${col}61`).border = {
                        bottom: thinBorder,
                    };
                }

                // endregion

                // region 다운로드

                worksheet.pageSetup.printArea = 'A1:I61';

                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });

                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = `[${userName}님]인보이스_${orderNo}_${DateViewValue}.xlsx`;
                anchor.click();
                window.URL.revokeObjectURL(url);

                // endregion
            }
        } catch (error) {
            console.error(error);
        }
    };

    const getProdStLabel = (prodSt) => {
        const prodStStyles = {
            IS00: "입고대기", IS01: "결제대기(상품)", IS02: "결제중(상품)",
            IS03: "결제완료(상품)", IS04: "구매완료", IS05: "센터도착",
            IS06: "패킹중", IS07: "결제대기(배송)", IS08: "결제중(배송)",
            IS09: "결제완료(배송)", IS10: "출고완료", IS11: "반송중",
            IS12: "신청취소", IS13: "구매중", IS14: "입고중"
        };
        return prodStStyles[prodSt] || "";
    };

    // 주문내역
    const excelDown = () => {
        try {
            const allData = [...filteredList];
            const selectedRowData = allData.filter((item) => selectedRows.includes(item.seqnum || item.seqNum));

            if (selectedRowData.length === 0) {
                setNonSelectedShow(true);
                return;
            }

            const excel = require('exceljs');
            const workbook = new excel.Workbook();
            workbook.created = new Date();
            workbook.modified = new Date();

            // region 주문상태(OS) & 상품상태(IS) 정의

            function interpretOrderStatus(status) {
                const statusMap = {
                    'OS00': '입고대기',
                    'OS01': '결제대기(상품)',
                    'OS02': '결제중(상품)',
                    'OS03': '결제대기(상품)',
                    'OS04': '구매중',
                    'OS05': '구매완료',
                    'OS06': '입고중',
                    'OS07': '센터도착',
                    'OS08': '패킹중',
                    'OS09': '결제대기(배송)',
                    'OS10': '결제중(배송)',
                    'OS11': '결제완료(배송)',
                    'OS12': '출고완료',
                    'OS13': '반송중',
                    'OS14': '출고완료',
                };
                return statusMap[status] || 'N/A';
            }

            function interpretPayStatus(status) {
                const statusMap = {
                    'PS0': '결제대기',
                    'PS1': '결제중',
                    'PS2': '결제완료',
                    'PS3': '출고완료',
                };
                return statusMap[status] || 'N/A';
            }

            function interpretProdType(status) {
                const statusMap = {
                    'P00': '장바구니',
                    'P01': '구매대행',
                    'P02': '오프라인',
                    'P03': '이체대행',
                    'P04': '국내배송',
                    'P05': '배송대행',
                };
                return statusMap[status] || 'N/A';
            }

            function interpretProdStatus(status) {
                const statusMap = {
                    'IS00': '입고대기',
                    'IS01': '결제대기(P)',
                    'IS02': '결제중(P)',
                    'IS03': '결제완료(P)',
                    'IS04': '구매완료',
                    'IS05': '센터도착',
                    'IS06': '패킹중',
                    'IS07': '결제대기(D)',
                    'IS08': '결제중(D)',
                    'IS09': '결제완료(D)',
                    'IS10': '출고완료',
                    'IS11': '반송중',
                    'IS12': '신청취소',
                    'IS13': '구매중',
                    'IS14': '입고중',
                };
                return statusMap[status] || 'N/A';
            }

            // endregion

            function getSafeValue(obj, key, defaultValue = '') {
                return obj && obj[key] !== undefined ? obj[key] : defaultValue;
            }

            function getSafeArray(obj, key) {
                return obj && Array.isArray(obj[key]) ? obj[key] : [];
            }

            // region 해당하는 열에 각 데이터 지정하여 전달

            function mapDataToExcelRows(item) {
                const productsDTO = item.type === 'orderdt'
                    ? getSafeArray(item, 'productsDTO')
                    : getSafeArray(item.packListDTO, 'productsDTO');

                // 수수료계열
                let ttEtcFee = 0;
                let etcFeeNm = '';
                let repackFee = 0;
                let agencyFee = 0;
                let removeFee = 0;
                let deliveryFee = 0;
                let comprFee = 0;

                // 할인
                let appSalePrice = 0;

                // 비용계열
                let ttEtcPrice = 0;
                let etcPriceNm = '';
                let returnFee = 0;
                let courierPay = 0;

                if (item.type === 'orderdt') {
                    const pt2PayInfo = (Array.isArray(item.payInfoDTO) ? item.payInfoDTO : [item.payInfoDTO])
                        .find(info => info?.payType === 'PT2');

                    ttEtcFee = pt2PayInfo?.ttEtcFee || 0; // 총기타수수료
                    etcFeeNm = pt2PayInfo?.etcFeeNm || ''; // 기타수수료명
                    repackFee = pt2PayInfo?.repackFee || 0; // 재포장수수료
                    agencyFee = pt2PayInfo?.agencyFee || 0; // 대행수수료
                    removeFee = pt2PayInfo?.removeFee || 0; // 제거작업 수수료
                    deliveryFee = pt2PayInfo?.deliveryFee || 0; // 배송대행수수료
                    comprFee = pt2PayInfo?.comprFee || 0; // 압축팩수수료

                    ttEtcPrice = pt2PayInfo?.ttEtcPrice || 0; // 총기타비용
                    etcPriceNm = pt2PayInfo?.etcPriceNm || ''; // 기타비용명
                    returnFee = pt2PayInfo?.returnFee || 0; // 국내반송료
                    courierPay = pt2PayInfo?.courierPay || 0; // 착불비
                }

                return productsDTO.map(product => ({
                    '여백': '',
                    '주문번호': item.type === 'orderdt' ? getSafeValue(item, 'orderNumber', '')
                        : `${getSafeValue(item.orderdtDTO, 'orderNumber', '')}-${getSafeValue(item.shipInfoDTO, 'boxNum', '')}`,
                    '주문유형': item.type === 'orderdt' ? '주문서' : '배송료',
                    '사서함번호': item.type === 'orderdt' ? 'BT' + getSafeValue(item.memberDTO, 'mbNum', '') : 'BT' + getSafeValue(item.orderdtDTO.memberDTO, 'mbNum', ''),
                    '고객명': item.type === 'orderdt' ? getSafeValue(item.memberDTO, 'userName', '') : getSafeValue(item.orderdtDTO.memberDTO, 'userName', ''),
                    '수취인명': getSafeValue(item.type === 'orderdt' ? item.recinfoDTO : item.appRecDTO, 'recname', ''),
                    '국가': `${getSafeValue(item.type === 'orderdt' ? item.recinfoDTO : item.appRecDTO, 'countryDTO', {}).countryNm || ''}[${getSafeValue(item.type === 'orderdt' ? item.recinfoDTO : item.appRecDTO, 'countryDTO', {}).countryCode || ''}]`,
                    '주문상태': item.type === 'orderdt' ? interpretOrderStatus(item.orderStatus) : interpretPayStatus(item.payStatus),
                    '서비스구분': interpretProdType(product.prodTy),
                    '개별상태': interpretProdStatus(product.prodSt),
                    '상품명': product.name,
                    '상품옵션': product.option,
                    '상품수량': product.quantity || 0,
                    '금액': product.price || 0,
                    '몰배송비': product.mallShipPrice || 0,
                    '상품수수료': product.fee || 0,
                    'URL': product.url || '',
                    '배송사': item.type === 'orderdt' ? getSafeValue(item, 'shipco', '') : (convertToShipco(item.dvType) || ''),
                    '운송장번호': item.type === 'orderdt' ? '' : getSafeValue(item.shipInfoDTO, 'outWayNum', ''),

                    // 조건 1 적용 (서로 겹치지 않게 처리 & 명칭 매핑 통일)
                    '국내반송료': item.type === 'orderdt' ? returnFee : 0,
                    '착불비': item.type === 'orderdt' ? courierPay : 0,
                    '기타비용': item.type === 'orderdt' ? ttEtcPrice : 0,
                    '기타비용내용': item.type === 'orderdt' ? etcPriceNm : '',
                    '재포장수수료': item.type === 'orderdt' ? repackFee : 0,
                    '대행수수료': item.type === 'orderdt' ? agencyFee : 0,
                    '제거작업수수료': item.type === 'orderdt' ? removeFee : 0,
                    '압축팩수수료': item.type === 'orderdt' ? comprFee : 0,
                    '배송대행수수료': item.type === 'orderdt' ? deliveryFee : 0,
                    '기타수수료': item.type === 'orderdt' ? ttEtcFee : 0,
                    '기타수수료내용': item.type === 'orderdt' ? etcFeeNm : '',

                    // 조건 2 적용 (앱할인은 음수처리)
                    '앱할인': item.type !== 'orderdt' ? (item.appSalePrice ? -Math.abs(item.appSalePrice) : 0) : 0,

                    'FedEx': item.type !== 'orderdt' ? getSafeValue(item, 'ttFedexPrice', 0) : 0,
                    'FedEx-E': item.type !== 'orderdt' ? getSafeValue(item, 'ttFedexEcoPrice', 0) : 0,
                    'UPS': item.type !== 'orderdt' ? getSafeValue(item, 'ttUpsPrice', 0) : 0,
                    'UPS-E': item.type !== 'orderdt' ? getSafeValue(item, 'ttUpsEcoPrice', 0) : 0,
                    'EMS': item.type !== 'orderdt' ? getSafeValue(item, 'ttEmsPrice', 0) : 0,
                    'EMSP': item.type !== 'orderdt' ? getSafeValue(item, 'ttEmsPrePrice', 0) : 0,
                    'Kpack': item.type !== 'orderdt' ? getSafeValue(item, 'ttKPackPrice', 0) : 0,
                    'Small-Packet': item.type !== 'orderdt' ? getSafeValue(item, 'ttAirSPrice', 0) : 0,
                    'Sea': item.type !== 'orderdt' ? getSafeValue(item, 'ttSeaPrice', 0) : 0,

                    '출고일시': item.type === 'orderdt' ? getSafeValue(item, 'shipTime', '') : item.type === 'payinfo' && (item.shipTime !== null && item.shipTime !== '') ?
                        getSafeValue(item, 'shipTime', '') : getSafeValue(item.shipInfoDTO, 'outRegTime', ''),
                }));
            }

            // endregion

            // region 헤더(1행)의 값과 스타일 지정

            const sheetConfigs = {
                'Btorage Order': {
                    name: 'Btorage Order',
                    columns: [
                        {header: '', key: '여백', width: 0.5},
                        {header: '주문번호', key: '주문번호', width: 25, style: {alignment: {horizontal: 'center'}}},
                        {header: '주문유형', key: '주문유형', width: 12, style: {alignment: {horizontal: 'center'}}},
                        {header: '사서함번호', key: '사서함번호', width: 12, style: {alignment: {horizontal: 'center'}}},
                        {header: '고객명', key: '고객명', width: 23, style: {alignment: {horizontal: 'center'}}},
                        {header: '수취인명', key: '수취인명', width: 23, style: {alignment: {horizontal: 'center'}}},
                        {header: '국가', key: '국가', width: 18, style: {alignment: {horizontal: 'center'}}},
                        {header: '주문상태', key: '주문상태', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '서비스구분', key: '서비스구분', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: '개별상태', key: '개별상태', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '상품명', key: '상품명', width: 30},
                        {header: '상품옵션', key: '상품옵션', width: 30},
                        {header: '상품수량', key: '상품수량', width: 12, style: {alignment: {horizontal: 'center'}}},
                        {header: '금액', key: '금액', width: 12, style: {alignment: {horizontal: 'center'}}},
                        {header: '몰배송비', key: '몰배송비', width: 12, style: {alignment: {horizontal: 'center'}}},
                        {header: '상품수수료', key: '상품수수료', width: 12, style: {alignment: {horizontal: 'center'}}},
                        {header: 'URL', key: 'URL', width: 10},
                        {header: '배송사', key: '배송사', width: 12, style: {alignment: {horizontal: 'center'}}},
                        {header: '운송장번호', key: '운송장번호', width: 20, style: {alignment: {horizontal: 'center'}}},

                        // 추가된 컬럼들 반영
                        {header: '국내반송료', key: '국내반송료', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '착불비', key: '착불비', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '기타비용', key: '기타비용', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '기타비용내용', key: '기타비용내용', width: 40},
                        {header: '재포장수수료', key: '재포장수수료', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '대행수수료', key: '대행수수료', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '제거작업수수료', key: '제거작업수수료', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '압축팩수수료', key: '압축팩수수료', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '배송대행수수료', key: '배송대행수수료', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '기타수수료', key: '기타수수료', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: '기타수수료내용', key: '기타수수료내용', width: 40},

                        {header: '앱할인', key: '앱할인', width: 15, style: {alignment: {horizontal: 'center'}}},
                        {header: 'FedEx', key: 'FedEx', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: 'FedEx-E', key: 'FedEx-E', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: 'UPS', key: 'UPS', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: 'UPS-E', key: 'UPS-E', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: 'EMS', key: 'EMS', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: 'EMSP', key: 'EMSP', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: 'Kpack', key: 'Kpack', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {
                            header: 'Small-Packet',
                            key: 'Small-Packet',
                            width: 13,
                            style: {alignment: {horizontal: 'center'}}
                        },
                        {header: 'Sea', key: 'Sea', width: 13, style: {alignment: {horizontal: 'center'}}},
                        {header: '출고일시', key: '출고일시', width: 20, style: {alignment: {horizontal: 'center'}}},
                    ],
                }
            };

            // endregion

            const borderHeaderStyle = {
                top: {style: 'thin', color: {argb: 'FF000000'}},
                left: {style: 'thin', color: {argb: 'FF000000'}},
                bottom: {style: 'thin', color: {argb: 'FF000000'}},
                right: {style: 'thin', color: {argb: 'FF000000'}}
            };

            const applyBordersToRow = (row, border) => {
                row.eachCell({includeEmpty: true}, (cell) => {
                    cell.border = border;
                });
            };

            const createSheet = (name, columns) => {
                const sheet = workbook.addWorksheet(name);
                sheet.columns = columns;
                return sheet;
            };

            // region 주문서와 배송료를 한눈에 구분하기 위해 색상 칠

            const addRowsToSheet = (sheet, rows, border) => {
                rows.forEach((item) => {
                    const row = sheet.addRow(item);

                    //주문번호 열
                    const orderNumberCell = row.getCell('주문번호');
                    const orderNumberValue = orderNumberCell.value ? orderNumberCell.value.toString() : '';
                    orderNumberCell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: {argb: orderNumberValue.includes('-') ? 'edf5fa' : 'fffae8'},
                    };

                    //주문유형 열
                    const orderTypeCell = row.getCell('주문유형');
                    orderTypeCell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: {argb: orderTypeCell.value === '주문서' ? 'fffae8' : 'edf5fa'},
                    };

                    // URL 열 하위 값들 하이퍼링크 적용
                    const urlCell = row.getCell('URL');
                    if (
                        urlCell.value &&
                        typeof urlCell.value === 'string' &&
                        (urlCell.value.startsWith('http://') || urlCell.value.startsWith('https://'))
                    ) {
                        urlCell.value = {text: urlCell.value, hyperlink: urlCell.value};
                        urlCell.font = {color: {argb: 'FF0000FF'}, underline: true, name: '맑은 고딕', size: 10};
                    }

                    row.eachCell({includeEmpty: true}, (cell) => {
                        // URL 셀은 별도 폰트 설정을 유지
                        if(cell._column.key !== 'URL'){
                            cell.font = {name: '맑은 고딕', size: 10};
                        }
                    });
                    applyBordersToRow(row, border);
                });
            };

            // endregion

            // region 병합할 행열 지정 (배열을 받아 처리하는 형태로 리팩토링)

            const mergeCellsByCondition = (sheet, columnsToMerge) => {
                let startRow = 3; // 데이터 시작 행 (1행: 헤더, 2행: 합계)
                while (startRow <= sheet.rowCount) {
                    const matchValues = columnsToMerge.map(col => sheet.getCell(`${col}${startRow}`).value);
                    let endRow = startRow;

                    while (endRow + 1 <= sheet.rowCount) {
                        const nextValues = columnsToMerge.map(col => sheet.getCell(`${col}${endRow + 1}`).value);
                        const isMatch = matchValues.every((val, index) => val === nextValues[index]);

                        if (isMatch) {
                            endRow++;
                        } else {
                            break;
                        }
                    }

                    if (endRow > startRow) {
                        columnsToMerge.forEach(col => {
                            sheet.mergeCells(`${col}${startRow}:${col}${endRow}`);
                            const mergedCell = sheet.getCell(`${col}${startRow}`);
                            mergedCell.alignment = { vertical: 'middle', horizontal: 'center' };
                        });
                    }

                    startRow = endRow + 1; // 다음 그룹으로 이동
                }
            };

            // endregion

            const transformedRows = selectedRowData.flatMap(mapDataToExcelRows);

            if (sheetConfigs) {
                const sheet = createSheet(sheetConfigs['Btorage Order'].name, sheetConfigs['Btorage Order'].columns);

                //행 고정
                sheet.views = [
                    {state: 'frozen', xSplit: 5, ySplit: 2, activeCell: 'F3'}
                ];

                // region 주문유형 - 배송료 헤더를 색칠(주문서와 배송료 구분하기 좋게)

                const targetHeaders = [
                    '운송장번호',
                    '국내반송료',
                    '착불비',
                    '기타비용',
                    '기타비용내용',
                    '재포장수수료',
                    '대행수수료',
                    '제거작업수수료',
                    '압축팩수수료',
                    '배송대행수수료',
                    '기타수수료',
                    '기타수수료내용',
                    '앱할인',
                    'FedEx',
                    'FedEx-E',
                    'UPS',
                    'UPS-E',
                    'EMS',
                    'EMSP',
                    'Kpack',
                    'Small-Packet',
                    'Sea',
                    '출고일시'
                ];

                const headerRow = sheet.getRow(1);
                headerRow.eachCell((cell) => {
                    cell.alignment = {horizontal: 'center'};
                    cell.font = {bold: true, name: '맑은 고딕', size: 11};

                    if (targetHeaders.includes(cell.value)) {
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: {argb: 'edf5fa'}
                        };
                    }
                });

                // endregion

                const columnMap = {};
                sheet.columns.forEach((col) => {
                    if (col.key && col.letter) {
                        columnMap[col.key] = col.letter;
                    }
                });

                // 데이터 행 범위 설정 (데이터는 3행부터 시작)
                const dataStartRow = 3;
                const dataEndRow = dataStartRow + transformedRows.length - 1;

                // region 지정된 열 하위 행의 값들 합산

                const sumKeys = ['상품수량', '금액', '몰배송비', '상품수수료', '국내반송료', '착불비', '기타비용', '재포장수수료', '대행수수료', '제거작업수수료', '압축팩수수료', '배송대행수수료', '기타수수료', '앱할인', 'FedEx', 'FedEx-E', 'UPS', 'UPS-E', 'EMS', 'EMSP', 'Kpack', 'Small-Packet', 'Sea'];

                const summaryRow = {};
                sheetConfigs['Btorage Order'].columns.forEach(col => {
                    summaryRow[col.key] = '';
                });

                // 첫열에 텍스트 표시
                summaryRow['주문번호'] = '합계';

                // 합계 대상 열에는 수식 지정
                sumKeys.forEach((key) => {
                    const colLetter = columnMap[key];
                    if (colLetter) {
                        summaryRow[key] = {formula: `SUM(${colLetter}${dataStartRow}:${colLetter}${dataEndRow})`};
                    }
                });

                sheet.spliceRows(2, 0, summaryRow);

                const summaryExcelRow = sheet.getRow(2);
                for (let col = 2; col <= 40; col++) { // 총 40개 컬럼까지 스타일 적용
                    const cell = summaryExcelRow.getCell(col);
                    cell.alignment = {horizontal: 'right'};
                    cell.font = {name: '맑은 고딕', size: 10, bold: true, color: {argb: 'FFFF0000'}};
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: {argb: 'f1f1f1'}
                    };

                    // 숫자인 경우 통화단위 표시
                    if (
                        (typeof cell.value === 'number') ||
                        (cell.value && typeof cell.value === 'object' && cell.value.formula)
                    ) {
                        cell.numFmt = '#,##0';
                    }
                }

                addRowsToSheet(sheet, transformedRows, borderHeaderStyle);

                sheet.eachRow({includeEmpty: true}, (row) => {
                    for (let col = 2; col <= 5; col++) { //B~E열에 해당하는 값들 Bold
                        const cell = row.getCell(col);
                        cell.font = {...(cell.font || {}), bold: true};
                    }
                });

                // region 병합할 열 전달 (리팩토링 된 함수 사용)

                mergeCellsByCondition(sheet, [
                    'B', 'C', 'D', 'E', 'F', 'G', 'H', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
                    'AA', 'AB', 'AC', 'AD', 'AE', 'AF', 'AG', 'AH', 'AI', 'AJ', 'AK', 'AL', 'AM', 'AN'
                ]);

                // endregion
            }

            const fileName = `[Btorage]Order_List_${DateViewValue}.xlsx`;
            workbook.xlsx.writeBuffer().then((data) => {
                const blob = new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = fileName;
                anchor.click();
                window.URL.revokeObjectURL(url);
            });

        } catch (error) {
            console.error(error);
        }
    }

    // 출고내역
    const excelOrderDown = async () => {
        try {
            const allData = [...filteredList];
            // 체크된 데이터 필터링
            let selectedRowData = allData.filter((item) => selectedRows.includes(item.seqnum || item.seqNum));

            // type이 'payinfo'인 데이터 제외 (orderdt만 다운로드)
            selectedRowData = selectedRowData.filter(item => item.type !== 'payinfo');

            if (selectedRowData.length === 0) {
                setNonSelectedShow(true);
                return;
            }

            const excel = require('exceljs');
            const workbook = new excel.Workbook();
            workbook.created = new Date();
            workbook.modified = new Date();

            const worksheet = workbook.addWorksheet('Order History');

            // 1. 헤더 설정 (A ~ K열)
            worksheet.columns = [
                { header: 'OrderNumber', key: 'colA', width: 20 },
                { header: 'Name', key: 'colB', width: 15 },
                { header: 'Tell', key: 'colC', width: 15 },
                { header: 'Address', key: 'colD', width: 45 },
                { header: 'Domestic Delivery Company', key: 'colE', width: 25 },
                { header: 'Domestic Tracking Number', key: 'colF', width: 25 },
                { header: 'Product Name', key: 'colG', width: 30 },
                { header: 'ProdSt', key: 'colH', width: 15 },
                { header: 'Overseas Tracking Number', key: 'colI', width: 25 }, // [New Logic Apply]
                { header: 'Order Form Payment Amount', key: 'colJ', width: 25 },
                { header: 'Shipping Fee Payment Amount', key: 'colK', width: 25 },
            ];

            // 2. 데이터 루프 및 가공
            selectedRowData.forEach((data) => {

                // --- J열 Total Amount 계산 ---
                let orderFormPaymentAmount = 0;

                // productsDTO 합산
                const prodSum = data.productsDTO?.reduce((sum, item) => {
                    const isValidSt = item.prodSt !== "IS01" && item.prodSt !== "IS02" && item.prodSt !== "IS12";
                    return (isValidSt && item.price > 0) ? sum + item.price + item.mallShipPrice + item.fee : sum;
                }, 0) || 0;

                // payInfoDTO 합산
                const payInfoSum = data.payInfoDTO?.reduce((sum, item) => {
                    const isValidStatus = item.payStatus !== "PS0" && item.payStatus !== "PS1";
                    const isValidClass = item.payClass === '1';
                    return (isValidStatus && isValidClass && item.ttProdExpense > 0) ? sum + item.ttProdExpense : sum;
                }, 0) || 0;

                orderFormPaymentAmount = prodSum + payInfoSum;


                // --- K열 Shipping Fee & I열 Overseas Tracking 계산 ---
                let shippingFeePaymentAmount = 0;
                let overseasTracking = null; // 초기값 null

                // payInfoDTO를 순회하며 조건 체크
                if (data.payInfoDTO && Array.isArray(data.payInfoDTO)) {
                    data.payInfoDTO.forEach(item => {
                        // 조건: payType이 PT1이고, payStatus가 PS2 혹은 PS3
                        if (item.payType === 'PT1' && (item.payStatus === 'PS2' || item.payStatus === 'PS3')) {
                            // K열 값 누적
                            shippingFeePaymentAmount += (item.ttShipExpense || 0);

                            // [조건 변경 반영] I열 값 추출: 해당 조건 데이터의 shipInfoDTO.outWayNum
                            if (item.shipInfoDTO && item.shipInfoDTO.outWayNum) {
                                overseasTracking = item.shipInfoDTO.outWayNum;
                            }
                        }
                    });
                }

                // --- 1 Order -> N Rows (productsDTO 기준) ---
                const products = data.productsDTO && data.productsDTO.length > 0 ? data.productsDTO : [{}];

                products.forEach((prod) => {
                    // recinfoDTO (소문자 i) 사용
                    const addressFull = data.recinfoDTO
                        ? `${data.recinfoDTO.address1 || ''} ${data.recinfoDTO.address2 || ''} ${data.recinfoDTO.address3 || ''} ${data.recinfoDTO.city || ''}`.trim()
                        : '';

                    const rowValues = {
                        colA: data.orderNumber,
                        colB: data.memberDTO?.userName,
                        colC: data.recinfoDTO?.telnum,
                        colD: addressFull,
                        colE: prod.domShipco || null,
                        colF: prod.inWaynum || null,
                        colG: prod.name,
                        colH: getProdStLabel(prod.prodSt),
                        colI: overseasTracking,         // 계산된 Overseas Tracking Number
                        colJ: orderFormPaymentAmount,
                        colK: shippingFeePaymentAmount
                    };

                    worksheet.addRow(rowValues);
                });
            });

            // 3. 스타일링 적용
            const headerRow = worksheet.getRow(1);
            headerRow.height = 30;
            headerRow.eachCell((cell) => {
                cell.font = {
                    name: 'Arial',
                    size: 11,
                    bold: true,
                    color: { argb: 'FFFFFFFF' } // 흰색 폰트
                };
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    // 헤더 배경색: 주황색 (FFBE48)
                    fgColor: { argb: 'FFFFBE48' }
                };
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });

            // 데이터 행 스타일 (모두 가운데 정렬)
            worksheet.eachRow((row, rowNumber) => {
                if (rowNumber > 1) {
                    row.eachCell((cell, colNumber) => {
                        cell.font = { name: 'Arial', size: 10 };

                        // 모든 데이터 정중앙 배치
                        cell.alignment = {
                            vertical: 'middle',
                            horizontal: 'center',
                            wrapText: true
                        };

                        cell.border = {
                            top: { style: 'thin', color: { argb: 'FFD9D9D9' } },
                            left: { style: 'thin', color: { argb: 'FFD9D9D9' } },
                            bottom: { style: 'thin', color: { argb: 'FFD9D9D9' } },
                            right: { style: 'thin', color: { argb: 'FFD9D9D9' } }
                        };

                        // 금액 컬럼(J=10, K=11) 숫자 콤마 포맷 적용
                        if(colNumber === 10 || colNumber === 11) {
                            cell.numFmt = '#,##0';
                        }
                    });
                }
            });

            // 4. 파일 다운로드 (file-saver 없이 순수 JS 구현)
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = `[Btorage]Shipment_List_${new Date().toISOString().slice(0,10)}.xlsx`;
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("주문서 엑셀내역 다운로드 실패 : ", error);
        }
    };

    const [guidePopupOrderSt, setGuidePopupOrderSt] = useState({});
    const openGuidePopupOrder = (index) => {
        setGuidePopupOrderSt(prevStates => ({...prevStates, [index]: true}));
    }
    const closeGuidePopupOrder = (index) => {
        setGuidePopupOrderSt(prevStates => ({...prevStates, [index]: false}));
    }

    const [guidePopupPaySt, setGuidePopupPaySt] = useState({});
    const openGuidePopupPay = ((index) => {
        setGuidePopupPaySt(prevStates => ({...prevStates, [index]: true}));
    })
    const closeGuidePopupPay = ((index) => {
        setGuidePopupPaySt(prevStates => ({...prevStates, [index]: false}));
    })

    const [integPayDetailPopupSt, setIntegPayDetailPopupSt] = useState(false);
    const [integPaySeqnum, setIntegPaySeqnum] = useState(null);
    const integPayDetail = ((seqnum) => {
        setIntegPaySeqnum(seqnum);
        setIntegPayDetailPopupSt(true)
    })
    const integDetailPopupClose = (() => {
        setIntegPayDetailPopupSt(false);
    })
    useEffect(() => {
        if (integPaySeqnum !== null) {
            setIntegPayDetailPopupSt(true);
        }
    }, [integPaySeqnum]);

    const [dontTrackingShipcoSt, setDontTrackingShipcoSt] = useState(false);
    const closeDontTrackingShipco = (() => {
        setDontTrackingShipcoSt(false);
    });

    const selectOsTrackNum = ((shipco, trackNum) => {
        const screenWidth = window.screen.width;
        const screenHeight = window.screen.height;
        const width = 1200;
        const height = 800;
        const left = (screenWidth / 2) - (width / 2);
        const top = (screenHeight / 2) - (height / 2);

        if (shipco === "FedEx" || shipco === "FedEx-E") {
            const url = `https://www.fedex.com/fedextrack/?trknbr=${trackNum}`;
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (shipco === "UPS" || shipco === "UPS-E") {
            const url = `https://www.ups.com/track?loc=ko_KR&trackNums=${trackNum}&requester=ST/trackdetails`;
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (shipco === "DHL") {
            const url = `https://www.dhl.com/kr-ko/home/tracking/tracking-ecommerce.html?submit=1&tracking-id=${trackNum}`;
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (shipco === "EMS" || shipco === "SEA" || shipco === "EMSP" || shipco === "K-Packet" || shipco === "Small-Packet") {
            const url = `https://service.epost.go.kr/trace.RetrieveEmsRigiTraceList.comm?POST_CODE=${trackNum}&displayHeader=N`;
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        }
    })

    const selectDsTrackNum = ((selectedDomestic, dsTrackNum) => {
        const screenWidth = window.screen.width;
        const screenHeight = window.screen.height;
        const width = 1200;
        const height = 800;
        const left = (screenWidth / 2) - (width / 2);
        const top = (screenHeight / 2) - (height / 2);

        if (selectedDomestic === "CJ대한통운" || selectedDomestic === "CJ 대한통운") {
            const url = `https://trace.cjlogistics.com/next/tracking.html?wblNo=${dsTrackNum}`;
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (selectedDomestic === "로젠택배") {
            const url = `https://www.ilogen.com/web/personal/trace/${dsTrackNum}`;
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (selectedDomestic === "우체국") {
            const url = `https://service.epost.go.kr/trace.RetrieveDomRigiTraceList.comm?sid1=${dsTrackNum}&displayHeader=N`
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (selectedDomestic === "한진택배") {
            const url = `https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillResult.do?mCode=MN038&schLang=KR&wblnumText2=${dsTrackNum}`
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (selectedDomestic === "롯데택배") {
            const url = `https://www.lotteglogis.com/open/tracking?invno=${dsTrackNum}`
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (selectedDomestic === "경동택배") {
            const url = `https://kdexp.com/newDeliverySearch.kd?barcode=${dsTrackNum}`
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else if (selectedDomestic === "국내배송") {
            const url = `https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillResult.do?mCode=MN038&schLang=KR&wblnumText2=${dsTrackNum}`
            window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
        } else {
            setDontTrackingShipcoSt(true);
        }
    })

    const orderStPrint = (orderSt) => {
        const orderStStyles = {
            OS00: {color: "#98B0D4", label: t(`prodStLabel1`)},
            OS01: {color: "#98B0D4", label: t(`prodStLabel2`)},
            OS02: {color: "#98B0D4", label: t(`prodStLabel3`)},
            OS03: {color: "#FFB378", label: t(`prodStLabel4`)},
            OS04: {color: "#98B0D4", label: t(`prodStLabel14`)},
            OS05: {color: "#EB939D", label: t(`prodStLabel5`)},
            OS06: {color: "#98B0D4", label: t(`prodStLabel15`)},
            OS07: {color: "#6EDA60", label: t(`prodStLabel6`)},
            OS08: {color: "#98B0D4", label: t(`prodStLabel7`)},
            OS09: {color: "#98B0D4", label: t(`prodStLabel8`)},
            OS10: {color: "#98B0D4", label: t(`prodStLabel9`)},
            OS11: {color: "#FFB378", label: t(`prodStLabel10`)},
            OS12: {color: "var(--mp-text-sub)", label: t(`prodStLabel11`)},
            OS13: {color: "#FF8F62", label: t(`prodStLabel12`)},
            OS14: {color: "#FF8F62", label: t(`prodStLabel13`)},
        };

        const style = orderStStyles[orderSt] || {color: "var(--mp-text)", label: null};
        return <p style={{
            margin: "0",
            color: style.color,
            fontSize: "14px",
            fontWeight: "bold",
            background: "var(--mp-panel)",
            padding: "6px 14px",
            borderRadius: "999px",
            display: "inline-block",
            whiteSpace: "nowrap"
        }}>{style.label}</p>;
    };

    const selectedTotalPricePrint = (pay) => {
        if (!pay) return;

        let prodTotal = 0;
        let shipTotal = 0;
        let etcTotal = 0;
        let integTotal = 0;

        // 상품금액 총합 계산
        if (pay.payType === "PT0") {
            const ttEtcFee = pay.ttEtcFee || 0;
            const ttProdExpense = pay.ttProdExpense || 0;
            prodTotal += ttEtcFee + ttProdExpense;
            return prodTotal;

            // 해외배송비 총합 계산
        } else if (pay.payType === "PT1") {
            const prices = [
                pay.ttFedexPrice, pay.ttFedexEcoPrice, pay.ttDhlPrice, pay.ttEmsPrice,
                pay.ttEmsPrePrice, pay.ttUpsPrice, pay.ttUpsEcoPrice, pay.ttKPackPrice,
                pay.ttAirSPrice, pay.ttSeaPrice, pay.ttDomPrice
            ];
            const validPrice = prices.find(price => price > 0) || 0;
            shipTotal += validPrice;
            return shipTotal;

            // 기타비용 총합 계산
        } else if (pay.payType === "PT2") {
            const courierPay = pay.courierPay || 0;
            const returnFee = pay.returnFee || 0;
            const deliveryFee = pay.deliveryFee || 0;
            const repackFee = pay.repackFee || 0;
            const agencyFee = pay.agencyFee || 0;
            const removeFee = pay.removeFee || 0;
            const comprFee = pay.comprFee || 0;
            const etcPrice = pay.etcPrice || 0;
            const etcFee = pay.etcFee || 0;
            etcTotal += courierPay + returnFee + deliveryFee + repackFee + agencyFee + removeFee + comprFee + etcPrice + etcFee;
            return etcTotal;
        } else if (pay.payType === "PT3") {
            const ttProdPrice = pay.ttProdExpense || 0;
            const ttEtcFee = pay.ttEtcFee || 0;
            const ttEtcPrice = pay.ttEtcPrice || 0;
            const ttShipExpense = pay.ttShipExpense || 0;
            integTotal += ttProdPrice + ttEtcFee + ttEtcPrice + ttShipExpense;
            return integTotal;
        }
    };

    // 현재 사용자 브라우저위치
    const pathComponent = window.location.pathname;

    const [activeTab, setActiveTab] = useState(0);
    const tabs = [
        {
            label: t(`myTab1`), content:
                <div>
                    <div className="mp-filterbar" style={{height: "80px", display: "flex", alignItems: "center", position: "relative"}}>
                        <button style={{
                            height: "40px",
                            minWidth: "200px",
                            borderColor: "lightgray",
                            border: "none",
                            backgroundColor: "var(--mp-panel)",
                            color: "var(--mp-text-sub)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "6px",
                            overflow: "hidden",
                            position: "relative"
                        }} ref={periodButtonRef}
                                onClick={() => setPeriodSelectShow(true)}>{periodSelectCommonValue}<i
                            style={{
                                fontSize: "27px",
                                position: "absolute",
                                right: "3px",
                                bottom: "2px"
                            }}><BiChevronDown/></i></button>
                        {
                            periodSelectShow === true ?
                                <div style={{
                                    width: "200px",
                                    height: "auto",
                                    border: "none",
                                    boxShadow: "0px 0px 10px lightgray",
                                    position: "absolute",
                                    left: "0",
                                    top: "70px",
                                    zIndex: 3,
                                    backgroundColor: "var(--mp-surface)",
                                    borderRadius: "6px"
                                }} ref={periodDivRef} onClick={periodDivHandle}>
                                    <button className="mypgFilterBt"
                                            onClick={() => periodBtHandle(t('myPrd1'))}>{t(`myPrd1`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => periodBtHandle(t('myPrd2'))}>{t(`myPrd2`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => periodBtHandle(t('myPrd3'))}>{t(`myPrd3`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => periodBtHandle(t('myPrd4'))}>{t(`myPrd4`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => periodBtHandle(t('myPrd5'))}>{t(`myPrd5`)}
                                    </button>
                                </div>
                                :
                                null
                        }
                        <button style={{
                            height: "40px",
                            minWidth: "200px",
                            borderColor: "lightgray",
                            border: "none",
                            backgroundColor: "var(--mp-panel)",
                            color: "var(--mp-text-sub)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "6px",
                            overflow: "hidden",
                            position: "relative",
                            marginLeft: "20px",
                        }} ref={orderTypeButtonRef}
                                onClick={() => setOrderTypeSelectShow(true)}>{orderTypeSelectCommonValue}<i
                            style={{
                                fontSize: "27px",
                                position: "absolute",
                                right: "3px",
                                bottom: "2px"
                            }}><BiChevronDown/></i></button>
                        {
                            orderTypeSelectShow ?
                                <div style={{
                                    width: "200px",
                                    height: "auto",
                                    border: "none",
                                    boxShadow: "0px 0px 10px lightgray",
                                    position: "absolute",
                                    left: "220px",
                                    top: "70px",
                                    zIndex: 3,
                                    backgroundColor: "var(--mp-surface)",
                                    borderRadius: "6px"
                                }} ref={orderTypeDivRef} onClick={orderTypeDivHandle}>
                                    <button className="mypgFilterBt"
                                            onClick={() => orderTypeBtHandle(t('orderType'))}>{t(`orderType`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => orderTypeBtHandle(t('myTab1'))}>{t(`myTab1`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => orderTypeBtHandle(t('deliveryOption'))}>{t(`deliveryOption`)}
                                    </button>
                                </div>
                                :
                                null
                        }
                        <div className="mp-status-wrap" style={{
                            width: "220px"
                        }}>
                            <button style={{
                                height: "40px",
                                width: "180px",
                                borderColor: "lightgray",
                                border: "none",
                                backgroundColor: "var(--mp-panel)",
                                color: "var(--mp-text-sub)",
                                display: "flex",
                                marginLeft: "20px",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: "6px",
                                overflow: "hidden",
                                position: "relative"
                            }} ref={orderStButtonRef}
                                    onClick={() => setOrderStSelectShow(true)}>{filterOrderSt(orderStSelectCommonValue)}<i
                                style={{
                                    fontSize: "27px",
                                    position: "absolute",
                                    right: "3px",
                                    bottom: "2px"
                                }}><BiChevronDown/></i></button>
                        </div>
                        {
                            orderStSelectShow === true ?
                                <div style={{
                                    width: "300px",
                                    height: "auto",
                                    border: "none",
                                    boxShadow: "0px 0px 10px lightgray",
                                    position: "absolute",
                                    left: "380px",
                                    top: "70px",
                                    zIndex: 3,
                                    backgroundColor: "var(--mp-surface)",
                                    borderRadius: "6px",
                                }} ref={orderStDivRef} onClick={orderStDivHandle}>
                                    <button className="mypgFilterBt"
                                            onClick={() => orderStBtHandle(t('state'))}>{t(`state`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => orderStBtHandle("OS00")}>{t(`prodStLabel1`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => orderStBtHandle("OS01")}>{t(`prodStLabel2`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => orderStBtHandle("OS02")}>{t(`prodStLabel3`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => orderStBtHandle("OS03")}>{t(`prodStLabel4`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => orderStBtHandle("OS04")}>{t(`prodStLabel14`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => orderStBtHandle("OS05")}>{t(`prodStLabel5`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => orderStBtHandle("OS06")}>{t(`prodStLabel15`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => orderStBtHandle("OS07")}>{t(`prodStLabel6`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => orderStBtHandle("OS08")}>{t(`prodStLabel7`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => orderStBtHandle("PS0")}>{t(`prodStLabel8`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => orderStBtHandle("PS1")}>{t(`prodStLabel9`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => orderStBtHandle("PS2")}>{t(`prodStLabel10`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => orderStBtHandle("PS3")}>{t(`prodStLabel11`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => orderStBtHandle("PS4")}>{t(`prodStLabel12`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => orderStBtHandle("PS5")}>{t(`prodStLabel13`)}
                                    </button>
                                </div>
                                :
                                null
                        }
                        <div style={{width: "250px", height: "40px", marginLeft: "20px", position: "relative"}}>
                            <input className="mypgSerchInput wd-100pc font-s-13 p-l-15" type="text"
                                   placeholder={t(`myPlaceHd`)} spellCheck="false"
                                   style={{
                                       width: "100%",
                                       border: "solid 1px var(--mp-border)",
                                       height: "100%",
                                       background: "var(--mp-surface)",
                                       color: "var(--mp-text)",
                                       borderRadius: "6px"
                                   }} value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}/>
                        </div>
                        {/*인보이스(주문서별 파일생성)*/}
                        <div>
                            <button className="ReviewPgWriteBtn" style={{
                                padding: "0 10px",
                                minWidth: "100px",
                                height: "40px",
                                fontSize: "13px",
                                borderWidth: "1px",
                                borderRadius: "4px",
                                marginLeft: "10px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }} onClick={invoiceDown}>{t(`modIvAccd`)}
                            </button>
                        </div>
                        {/*주문내역(주문서 내 모든 상품정보 내역)*/}
                        <div>
                            <button className="ReviewPgWriteBtn" style={{
                                padding: "0 10px",
                                minWidth: "100px",
                                height: "40px",
                                fontSize: "13px",
                                borderWidth: "1px",
                                borderRadius: "4px",
                                marginLeft: "10px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }} onClick={excelDown}>{t('mpTx5')}
                            </button>
                        </div>
                        {/*출고내역(모든 주문서 통합하여 하나의 파일에 생성)*/}
                        <div>
                            <button className="ReviewPgWriteBtn" style={{
                                padding: "0 10px",
                                minWidth: "100px",
                                height: "40px",
                                fontSize: "13px",
                                borderWidth: "1px",
                                borderRadius: "4px",
                                marginLeft: "10px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }} onClick={excelOrderDown}>{t('mpTx6')}
                            </button>
                        </div>
                    </div>
                    <div className="ht-auto m-t-30">
                        <div className="mp-list-head" style={{
                            height: "80px",
                            display: "flex",
                            // borderBottom: "1px solid #F2F2F2",
                            border: "none",
                            backgroundColor: "var(--mp-panel)",
                            zIndex: "2",
                            position: "sticky",
                            top: "55px",
                            boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.15)",
                        }}>
                            {/*체크박스*/}
                            <div style={{
                                width: "3%",
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}>
                                <input id="orderCheckBox" type="checkbox" checked={selectAll}
                                       className="myPgCustomCheckBox"
                                       onChange={handleSelectAllChange} style={{width: "20px", height: "20px"}}/>
                            </div>
                            {/*국가, 수취인성함*/}
                            <div style={{
                                width: "15%",
                                height: "100%",
                                display: "inline-block",
                                textAlign: "center",
                                color: "var(--mp-text-sub)"
                            }}>
                                <div className="m-t-15">
                                    <p className="font-s-13">{t(`modSmallMenu3`)}</p>
                                </div>
                                <div>
                                    <p style={{fontSize: "13px"}}>{t(`myHeader1`)}</p>
                                </div>
                            </div>
                            {/*상품명*/}
                            <div style={{
                                width: "25%",
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: "var(--mp-text-sub)",
                            }}>
                                <div>
                                    <p style={{margin: "0", color: "var(--mp-text-sub)", fontSize: "13px"}}>{t(`prodNm`)}</p>
                                </div>
                            </div>
                            {/*미결제, 결제완료*/}
                            <div style={{
                                width: "30%",
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: "var(--mp-text-sub)",
                            }}>
                                <div>
                                    <p style={{margin: "0", color: "var(--mp-text-sub)", fontSize: "13px"}}>{t(`myHeader2`)}</p>
                                </div>
                            </div>
                            {/*상태*/}
                            <div style={{
                                width: "12%",
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: "var(--mp-text-sub)",
                            }}>
                                <div>
                                    <p style={{
                                        margin: "0",
                                        color: "var(--mp-text-sub)",
                                        fontSize: "13px"
                                    }}>{t(`dchSmallMenu5`)}</p>
                                </div>
                            </div>
                            {/*출고일, 운송장번호*/}
                            <div style={{
                                width: "15%",
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: "var(--mp-text-sub)",
                            }}>
                                <div style={{textAlign: "center"}}>
                                    <p style={{margin: "0", color: "var(--mp-text-sub)", fontSize: "13px"}}>{t(`myHeader3`)}</p>
                                    <p style={{margin: "0", color: "var(--mp-text-sub)", fontSize: "13px"}}>{t(`prodTrNum`)}</p>
                                </div>
                            </div>
                        </div>
                        {orderdtList.length === 0 || filteredList.length === 0 ?
                            <div style={{
                                height: "500px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}>
                                <div style={{height: "100px", width: "30%"}}>
                                    <span style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        height: "100%"
                                    }}>
                                        <img style={{width: "50px", height: "50px", opacity: "0.5"}} alt=""
                                             src={noData}/><span style={{
                                        fontSize: "28px",
                                        marginLeft: "20px",
                                        fontWeight: "bold",
                                        color: "var(--mp-text-faint)"
                                    }}>No Data</span></span>
                                </div>
                            </div>
                            :
                            <div ref={myPgContentRef}>
                                {filteredList.slice(0, orderListDisplayLimit).map((order, index) => {
                                    let data1 = 0, data2 = 0, data3 = 0, data4 = 0;

                                    if (order.type === 'orderdt') {
                                        // 상품미결제 + 관리자가 등록한 상품누락금 미결제에 추가
                                        data1 = order.productsDTO?.reduce((sum, item) => {
                                            return (item.prodSt === "IS01" || item.prodSt === "IS02") && item.price > 0 ? sum + item.price + item.mallShipPrice + item.fee : sum;
                                        }, 0) || 0;
                                        data1 += order.payInfoDTO?.reduce((sum, item) => {
                                            return (item.payStatus === "PS0" || item.payStatus === "PS1") && item.payClass === '1'
                                            && item.ttProdExpense > 0 ? sum + item.ttProdExpense : sum;
                                        }, 0) || 0;

                                        // 상품총결제 + 관리자가 등록한 상품누락금 결제완료에 추가
                                        data2 = order.productsDTO?.reduce((sum, item) => {
                                            return item.prodSt !== "IS01" && item.prodSt !== "IS02" && item.prodSt !== "IS12" && item.price > 0 ? sum + item.price + item.mallShipPrice + item.fee : sum;
                                        }, 0) || 0;
                                        data2 += order.payInfoDTO?.reduce((sum, item) => {
                                            return item.payStatus !== "PS0" && item.payStatus !== "PS1" && item.payClass === '1'
                                            && item.ttProdExpense > 0 ? sum + item.ttProdExpense : sum;
                                        }, 0) || 0;

                                        // 기타미결제
                                        data3 = order.payInfoDTO?.reduce((sum, item) => {
                                            if ((item.payStatus === "PS0" || item.payStatus === "PS1") && item.payClass === '1') {
                                                // payStatus가 PS0 또는 PS1일 때 ttEtcPrice와 ttEtcFee(있을 경우)를 더함
                                                const etcPrice = item.ttEtcPrice > 0 ? item.ttEtcPrice : 0;
                                                const etcFee = item.ttEtcFee > 0 ? item.ttEtcFee : 0;
                                                return sum + etcPrice + etcFee;
                                            }
                                            return sum;
                                        }, 0) || 0;

                                        // 기타총결제
                                        data4 = order.payInfoDTO?.reduce((sum, item) => {
                                            if ((item.payStatus !== "PS0" && item.payStatus !== "PS1") && item.payClass === '1') {
                                                // payStatus가 PS0 또는 PS1일 때 ttEtcPrice와 ttEtcFee(있을 경우)를 더함
                                                const etcPrice = item.ttEtcPrice > 0 ? item.ttEtcPrice : 0;
                                                const etcFee = item.ttEtcFee > 0 ? item.ttEtcFee : 0;
                                                return sum + etcPrice + etcFee;
                                            }
                                            return sum;
                                        }, 0) || 0;
                                    }
                                    return (
                                        <div style={{margin: "auto"}}
                                             key={`order-${order.seqnum}-${index}`}>
                                            {/* orderdt map*/}
                                            {order.type === 'orderdt' ?
                                                <div style={{marginBottom: "30px"}}>
                                                    <div style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        fontSize: "19px",
                                                        borderTop: "solid",
                                                        borderWidth: "thin 1px",
                                                        borderColor: "#EDEDED",
                                                        padding: "20px 0",
                                                        // border:"solid"
                                                    }}>
                                                        <div className="mp-numstrip" style={{
                                                            width: "100%",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            height: "50px",
                                                            justifyContent: "space-between"
                                                        }}>
                                                            <div className="mp-numstrip-num" style={{
                                                                fontSize: "22px",
                                                                cursor: "pointer",
                                                                paddingLeft: "10px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                height: "100%",
                                                            }} onClick={myOrdPgMove(order.orderNumber)}>
                                                                <img alt="orderPacking" className="mp-num-icon" style={{
                                                                    width: "30px",
                                                                    height: "30px",
                                                                    marginRight: "20px"
                                                                }} src={mypgPayinfo}/>
                                                                {order?.orderNumber ? order.orderNumber : order.orderdtDTO?.orderNumber}
                                                                <span className="mp-type-badge mp-type-order">{t(`myTab1`)}</span>
                                                            </div>
                                                            <div className="mp-datebar" style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                height: "100%",
                                                            }}>
                                                                <div className="mp-date-chip" style={{
                                                                    width: "130px",
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    height: "20px",
                                                                    alignItems: "center",
                                                                    marginRight: "10px"
                                                                }}>{order.regDate ? `${order.regDate.substring(0, 4)}-${order.regDate.substring(4, 6)}-${order.regDate.substring(6, 8)}` : ''}
                                                                </div>
                                                                {order?.outWaynum ? <div className="mp-wb-chip" style={{
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    height: "20px",
                                                                }}>{order.outWaynum}</div> : null}
                                                                <div className="mp-ship-chip" style={{
                                                                    width: "90px",
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    height: "20px",
                                                                    alignItems: "center"
                                                                }}>{order.shipco}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="mp-order-row" style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        borderColor: "lightgray",
                                                        borderWidth: "thin 1px",
                                                        padding: "30px 0",
                                                    }}>
                                                        {/*오더 체크박스*/}
                                                        <div style={{
                                                            width: "3%",
                                                            height: "100%",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                        }}>
                                                            <input id="orderCheckBox" type="checkbox"
                                                                   checked={selectedRows.includes(order.seqnum)}
                                                                   onChange={() => handleCheckboxChange(order.seqnum)}
                                                                   style={{width: "20px", height: "20px"}}/>
                                                        </div>
                                                        {/*오더 국가, 수취인명*/}
                                                        <div className="mypgOrderCr" style={{
                                                            width: "15%",
                                                            margin: "auto",
                                                            display: "inline-block",
                                                            color: "var(--mp-text-sub)",
                                                            textAlign: "center",
                                                        }}>
                                                            <div style={{
                                                                fontSize: "15px",
                                                                fontWeight: "bold"
                                                            }}>{order.recinfoDTO && order.recinfoDTO.countryDTO.countryEngNm}</div>
                                                            <div>{order.recinfoDTO && order.recinfoDTO.recname}</div>
                                                        </div>
                                                        {/*오더 상품명*/}
                                                        <div className="display-block wd-25pc p-l-20 p-r-20">
                                                            {order.productsDTO && order.productsDTO.slice(0, 10).map((prod, prodIndex) => (
                                                                <div key={`product-${prod.seqnum}-${prodIndex}`}
                                                                     className="mypgOrderCr" style={{
                                                                    height: "auto",
                                                                    alignItems: "center",
                                                                    color: "var(--mp-text-sub)",
                                                                    fontSize: "15px"
                                                                }}>
                                                                    <div style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        height: "30px"
                                                                    }}>
                                                                    <span style={{fontSize: "13px", color: "var(--mp-text-sub)"}}>
                                                                        {
                                                                            prod.prodTy === "P00" ? t(`myProdTy1`) :
                                                                                prod.prodTy === "P01" ? t(`myProdTy2`) :
                                                                                    prod.prodTy === "P02" ? t(`myProdTy3`) :
                                                                                        prod.prodTy === "P03" ? t(`myProdTy4`) :
                                                                                            prod.prodTy === "P04" ? t(`myProdTy5`) :
                                                                                                prod.prodTy === "P05" ? t(`myProdTy6`) :
                                                                                                    null
                                                                        }
                                                                    </span>
                                                                        <span style={{
                                                                            margin: "0",
                                                                            fontSize: "13px",
                                                                            marginLeft: "5px",
                                                                            overflow: "hidden",
                                                                            textOverflow: "ellipsis",
                                                                            whiteSpace: "nowrap",
                                                                            wordBreak: "break-all"
                                                                        }}>
                                                                        {prod.name}
                                                                    </span>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        {/*오더 미결제, 결제완료*/}
                                                        <div className="p-l-15 p-r-15 wd-30pc">
                                                            <div style={{
                                                                display: "flex",
                                                                padding: "20px",
                                                                backgroundColor: "var(--mp-surface)",
                                                                borderRadius: "10px",
                                                                boxShadow: "0 5px 8px 0 rgba(0,0,0,0.1)"
                                                            }}>
                                                                <div style={{width: "80%"}}>
                                                                    <div style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        height: "40px"
                                                                    }}>
                                                                        <img style={{
                                                                            width: "22px",
                                                                            height: "22px",
                                                                            marginRight: "5px"
                                                                        }} src={mypgPayCardOrder} alt=""/>
                                                                        <span style={{
                                                                            margin: "0",
                                                                            fontSize: "16px",
                                                                            color: "var(--mp-text)",
                                                                            fontWeight: "bold"
                                                                        }}>{t(`myOrddtCardHeader1`)}</span>
                                                                    </div>
                                                                    <div style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        marginTop: "10px"
                                                                    }}>
                                                                        <div style={{
                                                                            width: "85%",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            height: "40px",
                                                                            justifyContent: "space-between"
                                                                        }}>
                                                                        <span style={{
                                                                            margin: "0",
                                                                            fontSize: "14px",
                                                                            color: "var(--mp-text)"
                                                                        }}>{t(`myOrddtCardHeader2`)}</span>
                                                                            <span style={{
                                                                                margin: "0 0 0 10px",
                                                                                fontSize: "15px",
                                                                                color: data1 > 0 ? "darkorange" : "var(--mp-text)",
                                                                                fontWeight: data1 > 0 ? "bold" : null
                                                                            }}>{data1?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        style={{display: "flex", alignItems: "center"}}>
                                                                        <div style={{
                                                                            width: "85%",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            height: "40px",
                                                                            justifyContent: "space-between"
                                                                        }}>
                                                                        <span style={{
                                                                            margin: "0",
                                                                            fontSize: "14px",
                                                                            color: "var(--mp-text)"
                                                                        }}>{t(`myOrddtCardHeader3`)}</span>
                                                                            <span style={{
                                                                                margin: "0 0 0 10px",
                                                                                fontSize: "15px",
                                                                                color: "var(--mp-text)"
                                                                            }}>{data2?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        style={{display: "flex", alignItems: "center"}}>
                                                                        <div style={{
                                                                            width: "85%",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            height: "40px",
                                                                            justifyContent: "space-between"
                                                                        }}>
                                                                        <span style={{
                                                                            margin: "0",
                                                                            fontSize: "14px",
                                                                            color: "var(--mp-text)"
                                                                        }}>{t(`myOrddtCardHeader4`)}</span>
                                                                            <span style={{
                                                                                margin: "0 0 0 10px",
                                                                                fontSize: "15px",
                                                                                color: data3 > 0 ? "darkorange" : "var(--mp-text)",
                                                                                fontWeight: data3 > 0 ? "bold" : null
                                                                            }}>{data3?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        style={{display: "flex", alignItems: "center"}}>
                                                                        <div style={{
                                                                            width: "85%",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            height: "40px",
                                                                            justifyContent: "space-between"
                                                                        }}>
                                                                        <span style={{
                                                                            margin: "0",
                                                                            fontSize: "14px",
                                                                            color: "var(--mp-text)"
                                                                        }}>{t(`myOrddtCardHeader`)}</span>
                                                                            <span style={{
                                                                                margin: "0 0 0 10px",
                                                                                fontSize: "15px",
                                                                                color: "var(--mp-text)",
                                                                            }}>{data4?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div style={{
                                                                    width: "20%",
                                                                    position: "relative",
                                                                    paddingBottom: "10px"
                                                                }}>
                                                                    <div style={{
                                                                        height: "50%",
                                                                        display: "flex",
                                                                        justifyContent: "flex-end"
                                                                    }}>
                                                                        <img onClick={() => openGuidePopupOrder(index)}
                                                                             style={{
                                                                                 width: "40px",
                                                                                 height: "40px",
                                                                                 cursor: "pointer"
                                                                             }} src={mypgWarn} alt=""/>
                                                                    </div>
                                                                    <div style={{
                                                                        height: "50%",
                                                                        display: "flex",
                                                                        justifyContent: "flex-end",
                                                                        alignItems: "flex-end"
                                                                    }}>
                                                                        <button onClick={myOrdPgMove(order.orderNumber)}
                                                                                style={{
                                                                                    width: "60px",
                                                                                    height: "40px",
                                                                                    border: "none",
                                                                                    background: "var(--mp-brand)",
                                                                                    marginTop: "auto",
                                                                                    borderRadius: "20px"
                                                                                }}>
                                                                        <span style={{
                                                                            margin: "0",
                                                                            fontSize: "13px",
                                                                            color: "white",
                                                                            fontWeight: "bold"
                                                                        }}>{t(`myDt`)}</span>
                                                                        </button>
                                                                    </div>
                                                                    {guidePopupOrderSt[index] ?
                                                                        <div style={{
                                                                            width: "300px",
                                                                            height: "170px",
                                                                            position: "absolute",
                                                                            backgroundColor: "var(--mp-surface)",
                                                                            boxShadow: "0 8px 16px 0 rgba(0,0,0,0.2)",
                                                                            zIndex: 3,
                                                                            top: 0,
                                                                            right: 0
                                                                        }}>
                                                                            <div style={{
                                                                                paddingTop: "8px",
                                                                                cursor: "pointer",
                                                                                height: "40px",
                                                                                top: "0",
                                                                                right: "5px",
                                                                                display: "flex",
                                                                                marginRight: "6px",
                                                                                borderBottom: "solid",
                                                                                borderWidth: "thin 1px",
                                                                                borderColor: "#E6E6E6",

                                                                            }}
                                                                                 onClick={() => closeGuidePopupOrder(index)}>
                                                                                <div style={{
                                                                                    width: "100%",
                                                                                    display: "flex",
                                                                                    justifyContent: "center",
                                                                                    alignItems: "center"
                                                                                }}>
                                                                                    <p style={{
                                                                                        margin: "0",
                                                                                        fontSize: "15px",
                                                                                        fontWeight: "bold"
                                                                                    }}>{t(`myCardHeader`)}</p>
                                                                                </div>
                                                                                <div style={{
                                                                                    position: "absolute",
                                                                                    right: "6px"
                                                                                }}>
                                                                                    <img style={{
                                                                                        width: "25px",
                                                                                        height: "25px"
                                                                                    }} src={commonClose} alt=""/>
                                                                                </div>
                                                                            </div>

                                                                            <div style={{
                                                                                width: "100%",
                                                                                height: "110px",
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                alignItems: "center"
                                                                            }}>
                                                                                <div>
                                                                                    <p style={{
                                                                                        margin: "0",
                                                                                        fontSize: "15px"
                                                                                    }}>
                                                                                        {t(`myOrddtCont1`)}
                                                                                        <button
                                                                                            onClick={myOrdPgMove(order.orderNumber)}
                                                                                            style={{
                                                                                                width: "50px",
                                                                                                height: "30px",
                                                                                                border: "none",
                                                                                                background: "var(--mp-brand)",
                                                                                                margin: "0 2px",
                                                                                                borderRadius: "20px"
                                                                                            }}>
                                                                                    <span style={{
                                                                                        margin: "0",
                                                                                        fontSize: "12px",
                                                                                        color: "white",
                                                                                        fontWeight: "bold"
                                                                                    }}>{t(`myDt`)}</span>
                                                                                        </button>
                                                                                        {t(`myOrddtCont2`)}
                                                                                    </p>
                                                                                    <p style={{
                                                                                        margin: "0",
                                                                                        fontSize: "15px",
                                                                                        marginTop: "5px"
                                                                                    }}>
                                                                                        {t(`myOrddtCont3`)}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        :
                                                                        null
                                                                    }

                                                                </div>

                                                            </div>
                                                        </div>
                                                        {/*오더 상태*/}
                                                        <div className="mp-status-cell" style={{
                                                            width: "12%",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            color: "var(--mp-text-sub)",
                                                        }}>
                                                            <div>
                                                                {orderStPrint(order?.orderStatus)}
                                                            </div>
                                                        </div>

                                                        {/*웹(PC)화면에서의 여백/공간*/}
                                                        <div className="mp-ship-cell" style={{
                                                            width: "15%",
                                                            color: "var(--mp-text-sub)",
                                                            margin: "auto",
                                                        }}>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                // payinfo map
                                                order.type === 'payinfo' && (order.payType === "PT1") ?
                                                    <div style={{marginBottom: "30px"}}
                                                         key={`pay-${order.seqNum}-${index}`}>
                                                        <div style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            fontSize: "19px",
                                                            borderTop: "solid",
                                                            borderWidth: "thin 1px",
                                                            borderColor: "#EDEDED",
                                                            padding: "20px 0"
                                                        }}>
                                                            <div className="mp-numstrip" style={{
                                                                width: "100%",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                height: "50px",
                                                                justifyContent: "space-between"
                                                            }}>
                                                                <div className="mp-numstrip-num" style={{
                                                                    fontSize: "22px",
                                                                    cursor: "pointer",
                                                                    paddingLeft: "10px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    height: "100%",
                                                                }}
                                                                     onClick={() => deliveryDetailTrueFn(order.seqNum, convertToShipco(order.dvType, order.orderdtDTO.shipco))}>
                                                                    <img alt="order" className="mp-num-icon" style={{
                                                                        width: "30px",
                                                                        height: "30px",
                                                                        marginRight: "20px"
                                                                    }} src={mypgOrderdt}/>
                                                                    {order?.orderNumber ? order.orderNumber : order.orderdtDTO?.orderNumber}
                                                                    -{order.shipInfoDTO.boxNum}
                                                                    <span className="mp-type-badge mp-type-pay">{t(`dvPr`)}</span>
                                                                </div>
                                                                <div className="mp-datebar" style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    height: "100%",
                                                                }}>
                                                                    <div className="mp-date-chip" style={{
                                                                        width: "130px",
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        height: "20px",
                                                                        alignItems: "center",
                                                                        marginRight: "10px"
                                                                    }}>{order?.shipInfoDTO?.outWayNum
                                                                        ? (order.shipInfoDTO.outRegDate ? `${order.shipInfoDTO.outRegDate.substring(0, 4)}-${order.shipInfoDTO.outRegDate.substring(4, 6)}-${order.shipInfoDTO.outRegDate.substring(6, 8)}` : '')
                                                                        : (order.regDate ? `${order.regDate.substring(0, 4)}-${order.regDate.substring(4, 6)}-${order.regDate.substring(6, 8)}` : '')}
                                                                    </div>
                                                                    <div className="mp-ship-chip" style={{
                                                                        width: "90px",
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        height: "20px",
                                                                        alignItems: "center"
                                                                    }}>{convertToShipco(order.dvType, order.orderdtDTO.shipco)}</div>
                                                                    {order?.shipInfoDTO?.outWayNum ? <div className="mp-wb-chip"
                                                                                                          onClick={() => {
                                                                                                              const shipco = convertToShipco(order.dvType);
                                                                                                              if (shipco === '국내배송') {
                                                                                                                  selectDsTrackNum(shipco, order.shipInfoDTO.outWayNum);
                                                                                                              } else {
                                                                                                                  selectOsTrackNum(shipco, order.shipInfoDTO.outWayNum);
                                                                                                              }
                                                                                                          }}
                                                                                                          style={{
                                                                                                              display: "flex",
                                                                                                              justifyContent: "center",
                                                                                                              alignItems: "center",
                                                                                                              height: "20px",
                                                                                                              cursor: "pointer",
                                                                                                              color: "#3B82F6",
                                                                                                          }}>{order?.shipInfoDTO?.outWayNum}</div> : null}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="mp-order-row" style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            borderColor: "lightgray",
                                                            borderWidth: "thin 1px",
                                                            padding: "30px 0",
                                                        }}>
                                                            {/*페이 체크박스*/}
                                                            <div style={{
                                                                width: "3%",
                                                                height: "100%",
                                                                display: "flex",
                                                                justifyContent: "center",
                                                            }}>
                                                                <input id="orderCheckBox" type="checkbox"
                                                                       checked={selectedRows.includes(order.seqNum)}
                                                                       onChange={() => handleCheckboxChange(order.seqNum)}
                                                                       style={{width: "20px", height: "20px"}}/>
                                                            </div>
                                                            {/*페이 국가, 수취인명*/}
                                                            <div className="mypgOrderCr" style={{
                                                                width: "15%",
                                                                margin: "auto",
                                                                display: "inline-block",
                                                                color: "var(--mp-text-sub)",
                                                                textAlign: "center",
                                                            }}>
                                                                <div style={{
                                                                    fontWeight: "bold",
                                                                    fontSize: "15px"
                                                                }}>{order.appRecDTO.countryDTO.countryEngNm}</div>
                                                                <div>{order.appRecDTO.recname}</div>
                                                            </div>
                                                            {/*페이 상품명*/}
                                                            <div className="display-block wd-25pc p-l-20 p-r-20">
                                                                {order.packListDTO && order.packListDTO.productsDTO && order.packListDTO.productsDTO.slice(0, 10).map((prod, prodIndex) => (
                                                                    <div key={`product-${prod.seqnum}-${prodIndex}`}
                                                                         className="mypgOrderCr" style={{
                                                                        height: "auto",
                                                                        alignItems: "center",
                                                                        color: "var(--mp-text-sub)",
                                                                        fontSize: "15px"
                                                                    }}>
                                                                        <div style={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            height: "30px"
                                                                        }}>
                                                                    <span style={{
                                                                        fontSize: "13px",
                                                                        color: "var(--mp-text-sub)"
                                                                    }}>
                                                                        {
                                                                            prod.prodTy === "P00" ? t(`myProdTy1`) :
                                                                                prod.prodTy === "P01" ? t(`myProdTy2`) :
                                                                                    prod.prodTy === "P02" ? t(`myProdTy3`) :
                                                                                        prod.prodTy === "P03" ? t(`myProdTy4`) :
                                                                                            prod.prodTy === "P04" ? t(`myProdTy5`) :
                                                                                                prod.prodTy === "P05" ? t(`myProdTy6`) :
                                                                                                    null
                                                                        }
                                                                    </span>
                                                                            <span style={{
                                                                                margin: "0",
                                                                                fontSize: "13px",
                                                                                marginLeft: "5px",
                                                                                color: "var(--mp-text-sub)",
                                                                                overflow: "hidden",
                                                                                textOverflow: "ellipsis",
                                                                                whiteSpace: "nowrap",
                                                                                wordBreak: "break-all"
                                                                            }}>
                                                                        {prod.name}
                                                                    </span>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className="wd-30pc p-l-15 p-r-15">
                                                                <div style={{
                                                                    display: "flex",
                                                                    padding: "20px",
                                                                    backgroundColor: "var(--mp-surface)",
                                                                    borderRadius: "10px",
                                                                    boxShadow: "0 5px 8px 0 rgba(0,0,0,0.1)"
                                                                }}>
                                                                    <div style={{width: "80%"}}>
                                                                        <div style={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            height: "40px"
                                                                        }}>
                                                                            <img style={{
                                                                                width: "23px",
                                                                                height: "23px",
                                                                                marginRight: "8px"
                                                                            }} src={mypgPayCardDelivery} alt=""/>
                                                                            <span style={{
                                                                                margin: "0",
                                                                                fontSize: "16px",
                                                                                color: "var(--mp-text)",
                                                                                fontWeight: "bold"
                                                                            }}>{t(`modSHeader6`)}</span> {/*해외배송비*/}
                                                                        </div>
                                                                        {/*FedEx*/}
                                                                        {order?.ttFedexPrice > 0 && (
                                                                            <div style={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                marginTop: "10px"
                                                                            }}>
                                                                                <div style={{
                                                                                    width: "85%",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    height: "40px",
                                                                                    justifyContent: "space-between"
                                                                                }}>
                                                                            <span style={{
                                                                                margin: "0",
                                                                                fontSize: "14px",
                                                                                color: "var(--mp-text)"
                                                                            }}>FedEx</span>
                                                                                    <span style={{
                                                                                        margin: "0",
                                                                                        fontSize: "15px",
                                                                                        color: order?.ttFedexPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") ? "darkorange" : "black",
                                                                                        fontWeight: order?.ttFedexPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") ? "bold" : "normal"
                                                                                    }}>
                                                                                {order?.ttFedexPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {/*FedEx-E*/}
                                                                        {order?.ttFedexEcoPrice > 0 && (
                                                                            <div style={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                            }}>
                                                                                <div style={{
                                                                                    width: "85%",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    height: "40px",
                                                                                    justifyContent: "space-between"
                                                                                }}>
                                                                            <span style={{
                                                                                margin: "0",
                                                                                fontSize: "14px",
                                                                                color: "var(--mp-text)"
                                                                            }}>FedEx-E</span>
                                                                                    <span style={{
                                                                                        margin: "0",
                                                                                        fontSize: "15px",
                                                                                        color: order?.ttFedexEcoPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") ? "darkorange" : "black",
                                                                                        fontWeight: order?.ttFedexEcoPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") ? "bold" : "normal"
                                                                                    }}>
                                                                                {order?.ttFedexEcoPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {/*UPS*/}
                                                                        {order?.ttUpsPrice > 0 && (
                                                                            <div style={{
                                                                                display: "flex",
                                                                                alignItems: "center"
                                                                            }}>
                                                                                <div style={{
                                                                                    width: "85%",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    height: "40px",
                                                                                    justifyContent: "space-between"
                                                                                }}>
                                                                            <span style={{
                                                                                margin: "0",
                                                                                fontSize: "14px",
                                                                                color: "var(--mp-text)"
                                                                            }}>UPS</span>
                                                                                    <span style={{
                                                                                        margin: "0",
                                                                                        fontSize: "15px",
                                                                                        color: order?.ttUpsPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") ? "darkorange" : "black",
                                                                                        fontWeight: order?.ttUpsPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") ? "bold" : "normal"
                                                                                    }}>
                                                                                {order?.ttUpsPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {/*UPS-E*/}
                                                                        {order?.ttUpsEcoPrice > 0 && (
                                                                            <div style={{
                                                                                display: "flex",
                                                                                alignItems: "center"
                                                                            }}>
                                                                                <div style={{
                                                                                    width: "85%",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    height: "40px",
                                                                                    justifyContent: "space-between"
                                                                                }}>
                                                                            <span style={{
                                                                                margin: "0",
                                                                                fontSize: "14px",
                                                                                color: "var(--mp-text)"
                                                                            }}>UPS-E</span>
                                                                                    <span style={{
                                                                                        margin: "0",
                                                                                        fontSize: "15px",
                                                                                        color: order?.ttUpsEcoPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") ? "darkorange" : "black",
                                                                                        fontWeight: order?.ttUpsEcoPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") ? "bold" : "normal"
                                                                                    }}>
                                                                                {order?.ttUpsEcoPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {/*EMS*/}
                                                                        {order?.ttEmsPrice > 0 && (
                                                                            <div style={{
                                                                                display: "flex",
                                                                                alignItems: "center"
                                                                            }}>
                                                                                <div style={{
                                                                                    width: "85%",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    height: "40px",
                                                                                    justifyContent: "space-between"
                                                                                }}>
                                                                            <span style={{
                                                                                margin: "0",
                                                                                fontSize: "14px",
                                                                                color: "var(--mp-text)"
                                                                            }}>EMS</span>
                                                                                    <span style={{
                                                                                        margin: "0",
                                                                                        fontSize: "15px",
                                                                                        color: order?.ttEmsPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") ? "darkorange" : "black",
                                                                                        fontWeight: order?.ttEmsPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") ? "bold" : "normal"
                                                                                    }}>
                                                                                {order?.ttEmsPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {/*EMSP*/}
                                                                        {order?.ttEmsPrePrice > 0 && (
                                                                            <div style={{
                                                                                display: "flex",
                                                                                alignItems: "center"
                                                                            }}>
                                                                                <div style={{
                                                                                    width: "85%",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    height: "40px",
                                                                                    justifyContent: "space-between"
                                                                                }}>
                                                                            <span style={{
                                                                                margin: "0",
                                                                                fontSize: "14px",
                                                                                color: "var(--mp-text)"
                                                                            }}>EMSP</span>
                                                                                    <span style={{
                                                                                        margin: "0",
                                                                                        fontSize: "15px",
                                                                                        color: order?.ttEmsPrePrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") ? "darkorange" : "black",
                                                                                        fontWeight: order?.ttEmsPrePrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") ? "bold" : "normal"
                                                                                    }}>
                                                                                {order?.ttEmsPrePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {/*K-Packet*/}
                                                                        {order?.ttKPackPrice > 0 && (
                                                                            <div style={{
                                                                                display: "flex",
                                                                                alignItems: "center"
                                                                            }}>
                                                                                <div style={{
                                                                                    width: "85%",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    height: "40px",
                                                                                    justifyContent: "space-between"
                                                                                }}>
                                                                            <span style={{
                                                                                margin: "0",
                                                                                fontSize: "14px",
                                                                                color: "var(--mp-text)"
                                                                            }}>K-Packet</span>
                                                                                    <span style={{
                                                                                        margin: "0",
                                                                                        fontSize: "15px",
                                                                                        color: order?.ttKPackPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") ? "darkorange" : "black",
                                                                                        fontWeight: order?.ttKPackPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") ? "bold" : "normal"
                                                                                    }}>
                                                                                {order?.ttKPackPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {/*항공소형포장물*/}
                                                                        {order?.ttAirSPrice > 0 && (
                                                                            <div style={{
                                                                                display: "flex",
                                                                                alignItems: "center"
                                                                            }}>
                                                                                <div style={{
                                                                                    width: "85%",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    height: "40px",
                                                                                    justifyContent: "space-between"
                                                                                }}>
                                                                            <span style={{
                                                                                margin: "0",
                                                                                fontSize: "14px",
                                                                                color: "var(--mp-text)"
                                                                            }}>Small-Packet</span>
                                                                                    <span style={{
                                                                                        margin: "0",
                                                                                        fontSize: "15px",
                                                                                        color: order?.ttAirSPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") ? "darkorange" : "black",
                                                                                        fontWeight: order?.ttAirSPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") ? "bold" : "normal"
                                                                                    }}>
                                                                                {order?.ttAirSPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {/*선편*/}
                                                                        {order?.ttSeaPrice > 0 && (
                                                                            <div style={{
                                                                                display: "flex",
                                                                                alignItems: "center"
                                                                            }}>
                                                                                <div style={{
                                                                                    width: "85%",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    height: "40px",
                                                                                    justifyContent: "space-between"
                                                                                }}>
                                                                            <span style={{
                                                                                margin: "0",
                                                                                fontSize: "14px",
                                                                                color: "var(--mp-text)"
                                                                            }}>SEA</span>
                                                                                    <span style={{
                                                                                        margin: "0",
                                                                                        fontSize: "15px",
                                                                                        color: order?.ttSeaPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") ? "darkorange" : "black",
                                                                                        fontWeight: order?.ttSeaPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") ? "bold" : "normal"
                                                                                    }}>
                                                                                {order?.ttSeaPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        {/*국내배송*/}
                                                                        {order.ttDomPrice > 0 ?
                                                                            <div style={{
                                                                                display: "flex",
                                                                                alignItems: "center"
                                                                            }}>
                                                                                <div style={{
                                                                                    width: "85%",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    height: "40px",
                                                                                    justifyContent: "space-between"
                                                                                }}>
                                                                            <span style={{
                                                                                margin: "0",
                                                                                fontSize: "14px",
                                                                                color: "var(--mp-text)"
                                                                            }}>{t(`myPayinfoCardHeader2`)}</span>
                                                                                    <span style={{
                                                                                        margin: "0",
                                                                                        fontSize: "15px",
                                                                                        color: order?.ttDomPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") ? "darkorange" : "black",
                                                                                        fontWeight: order?.ttDomPrice > 0 && (order.payStatus === "PS0" || order.payStatus === "PS1") ? "bold" : null
                                                                                    }}>
                                                                                {order?.ttDomPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                                                                                </div>
                                                                            </div>
                                                                            :
                                                                            null
                                                                        }
                                                                    </div>
                                                                    <div style={{
                                                                        width: "20%",
                                                                        position: "relative",
                                                                        paddingBottom: "10px",
                                                                    }}>
                                                                        <div style={{
                                                                            height: "50%",
                                                                            display: "flex",
                                                                            justifyContent: "flex-end"
                                                                        }}>
                                                                            <img
                                                                                onClick={() => openGuidePopupPay(index)}
                                                                                style={{
                                                                                    width: "40px",
                                                                                    height: "40px",
                                                                                    cursor: "pointer"
                                                                                }} src={mypgWarn} alt=""/>
                                                                        </div>
                                                                        <div style={{
                                                                            height: "50%",
                                                                            display: "flex",
                                                                            justifyContent: "flex-end",
                                                                            alignItems: "flex-end"
                                                                        }}>
                                                                            <button
                                                                                onClick={() => deliveryDetailTrueFn(order.seqNum, order.orderdtDTO.shipco)}
                                                                                style={{
                                                                                    width: "60px",
                                                                                    height: "40px",
                                                                                    border: "none",
                                                                                    background: "var(--mp-brand)",
                                                                                    marginTop: "auto",
                                                                                    borderRadius: "20px"
                                                                                }}>
                                                                            <span style={{
                                                                                margin: "0",
                                                                                fontSize: "13px",
                                                                                color: "white",
                                                                                fontWeight: "bold"
                                                                            }}>{t(`myDt`)}</span>
                                                                            </button>
                                                                        </div>
                                                                        {guidePopupPaySt[index] ?
                                                                            <div style={{
                                                                                width: "300px",
                                                                                height: "170px",
                                                                                position: "absolute",
                                                                                backgroundColor: "var(--mp-surface)",
                                                                                boxShadow: "0 8px 16px 0 rgba(0,0,0,0.2)",
                                                                                zIndex: 3,
                                                                                top: 0,
                                                                                right: 0
                                                                            }}>
                                                                                <div style={{
                                                                                    paddingTop: "8px",
                                                                                    cursor: "pointer",
                                                                                    height: "40px",
                                                                                    top: "0",
                                                                                    right: "5px",
                                                                                    display: "flex",
                                                                                    marginRight: "6px",
                                                                                    borderBottom: "solid",
                                                                                    borderWidth: "thin 1px",
                                                                                    borderColor: "#E6E6E6",

                                                                                }}
                                                                                     onClick={() => closeGuidePopupPay(index)}>
                                                                                    <div style={{
                                                                                        width: "100%",
                                                                                        display: "flex",
                                                                                        justifyContent: "center",
                                                                                        alignItems: "center"
                                                                                    }}>
                                                                                        <p style={{
                                                                                            margin: "0",
                                                                                            fontSize: "15px",
                                                                                            fontWeight: "bold"
                                                                                        }}>{t(`myCardHeader`)}</p>
                                                                                    </div>
                                                                                    <div style={{
                                                                                        position: "absolute",
                                                                                        right: "6px"
                                                                                    }}>
                                                                                        <img style={{
                                                                                            width: "25px",
                                                                                            height: "25px"
                                                                                        }} src={commonClose} alt=""/>
                                                                                    </div>
                                                                                </div>
                                                                                <div style={{
                                                                                    width: "100%",
                                                                                    height: "110px",
                                                                                    display: "flex",
                                                                                    justifyContent: "center",
                                                                                    alignItems: "center"
                                                                                }}>
                                                                                    <div>
                                                                                        <div
                                                                                            style={{marginBottom: "5px"}}>
                                                                                            <p style={{fontSize: "15px"}}>
                                                                                                {t(`myOrddtCont1`)}
                                                                                                <button
                                                                                                    onClick={() => deliveryDetailTrueFn(order.seqNum, order.orderdtDTO.shipco)}
                                                                                                    style={{
                                                                                                        width: "50px",
                                                                                                        height: "30px",
                                                                                                        border: "none",
                                                                                                        background: "var(--mp-brand)",
                                                                                                        margin: "0 2px",
                                                                                                        borderRadius: "20px"
                                                                                                    }}>
                                                                                                    <span style={{
                                                                                                        margin: "0",
                                                                                                        fontSize: "12px",
                                                                                                        color: "white",
                                                                                                        fontWeight: "bold"
                                                                                                    }}>{t(`myDt`)}</span>
                                                                                                </button>
                                                                                                {t(`myOrddtCont2`)}
                                                                                            </p>
                                                                                        </div>
                                                                                        <p style={{
                                                                                            fontSize: "15px",
                                                                                        }}>
                                                                                            {t(`myPayinfoCont`)}
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            :
                                                                            <div><br/></div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/*페이 상태*/}
                                                            <div className="mp-paystatus" style={{
                                                                width: "12%",
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                                color: "var(--mp-text-sub)",
                                                            }}>
                                                                <div>
                                                                    {order.payStatus === "PS0" ?
                                                                        <p style={{
                                                                            margin: "0",
                                                                            color: "#98B0D4",
                                                                            fontSize: "15px"
                                                                        }}>{t(`prodStLabel8`)}</p>
                                                                        :
                                                                        order.payStatus === "PS1" ?
                                                                            <p style={{
                                                                                margin: "0",
                                                                                color: "#98B0D4",
                                                                                fontSize: "15px"
                                                                            }}>{t(`prodStLabel9`)}</p>
                                                                            :
                                                                            order.payStatus === "PS2" ?
                                                                                <p style={{
                                                                                    margin: "0",
                                                                                    color: "#FFB378",
                                                                                    fontSize: "15px"
                                                                                }}>{t(`prodStLabel10`)}</p>
                                                                                :
                                                                                order.payStatus === "PS3" ?
                                                                                    <p style={{
                                                                                        margin: "0",
                                                                                        color: "var(--mp-text-sub)",
                                                                                        fontSize: "15px"
                                                                                    }}>{t(`prodStLabel11`)}</p>
                                                                                    :
                                                                                    order.payStatus === "PS4" ?
                                                                                        <p style={{
                                                                                            margin: "0",
                                                                                            color: "#FF8F62",
                                                                                            fontSize: "15px"
                                                                                        }}>{t(`prodStLabel12`)}</p>
                                                                                        :
                                                                                        order.payStatus === "PS5" ?
                                                                                            <p style={{
                                                                                                margin: "0",
                                                                                                color: "#FF8F62",
                                                                                                fontSize: "15px"
                                                                                            }}>{t(`prodStLabel13`)}</p>
                                                                                            :
                                                                                            null
                                                                    }
                                                                </div>
                                                            </div>

                                                            {/*웹(PC)화면에서의 여백/공간*/}
                                                            <div className="mp-ship-cell" style={{
                                                                width: "15%",
                                                                color: "var(--mp-text-sub)",
                                                                margin: "auto",
                                                            }}>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    :
                                                    null
                                            }
                                        </div>
                                    )
                                })}
                            </div>
                        }
                    </div>
                    {/*주문서탭 더보기버튼*/}
                    {
                        orderListDisplayLimit && filteredList && filteredList.length > orderListDisplayLimit ?
                            <div className="m-t-100 m-b-50 user-center font-s-17">
                                <button onClick={handleMoreOrderList}
                                        className="moreBt1 m-r-8 wd-100 ht-40 font-c-default m-r-8 font-s-14">More
                                </button>
                            </div>
                            :
                            null
                    }

                </div>
        },
        {
            label: t(`myTab2`), content:
                <div>
                    <div className="mp-filterbar" style={{height: "80px", display: "flex", alignItems: "center", position: "relative"}}>
                        <button style={{
                            height: "40px",
                            minWidth: "200px",
                            borderColor: "lightgray",
                            border: "none",
                            backgroundColor: "var(--mp-panel)",
                            color: "var(--mp-text-sub)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "6px",
                            overflow: "hidden",
                            position: "relative"
                        }} ref={payPeriodButtonRef}
                                onClick={() => setPayPeriodSelectShow(true)}>{payPeriodSelectCommonValue}<i
                            style={{
                                fontSize: "27px",
                                position: "absolute",
                                right: "3px",
                                bottom: "2px"
                            }}><BiChevronDown/></i></button>
                        {
                            payPeriodSelectShow ?
                                <div style={{
                                    width: "200px",
                                    height: "auto",
                                    border: "none",
                                    boxShadow: "0px 0px 10px lightgray",
                                    position: "absolute",
                                    left: "0",
                                    top: "70px",
                                    zIndex: 3,
                                    backgroundColor: "var(--mp-surface)",
                                    borderRadius: "6px"
                                }} ref={payPeriodDivRef} onClick={payPeriodDivHandle}>
                                    <button className="mypgFilterBt"
                                            onClick={() => payPeriodBtHandle(t('myPrd1'))}>{t(`myPrd1`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => payPeriodBtHandle(t('myPrd2'))}>{t(`myPrd2`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => payPeriodBtHandle(t('myPrd3'))}>{t(`myPrd3`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => payPeriodBtHandle(t('myPrd4'))}>{t(`myPrd4`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => payPeriodBtHandle(t('myPrd5'))}>{t(`myPrd5`)}
                                    </button>
                                </div>
                                :
                                null
                        }
                        <button style={{
                            height: "40px",
                            width: "180px",
                            borderColor: "lightgray",
                            border: "none",
                            backgroundColor: "var(--mp-panel)",
                            color: "var(--mp-text-sub)",
                            display: "flex",
                            marginLeft: "20px",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "6px",
                            overflow: "hidden",
                            position: "relative"
                        }} ref={payStButtonRef}
                                onClick={() => setPayStSelectShow(true)}>{filterPaySt(payStSelectCommonValue)}<i
                            style={{
                                fontSize: "27px",
                                position: "absolute",
                                right: "3px",
                                bottom: "2px"
                            }}><BiChevronDown/></i></button>
                        {
                            payStSelectShow === true ?
                                <div style={{
                                    width: "300px",
                                    height: "auto",
                                    border: "none",
                                    boxShadow: "0px 0px 10px lightgray",
                                    position: "absolute",
                                    left: "170px",
                                    top: "70px",
                                    zIndex: 3,
                                    backgroundColor: "var(--mp-surface)",
                                    borderRadius: "6px"
                                }} ref={payStDivRef} onClick={payStDivHandle}>
                                    <button className="mypgFilterBt"
                                            onClick={() => payStBtHandle(t('state'))}>{t(`state`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => payStBtHandle("PS0")}>{t(`prodStLabel8`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => payStBtHandle("PS1")}>{t(`prodStLabel9`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => payStBtHandle("PS2")}>{t(`prodStLabel10`)}
                                    </button>
                                </div>
                                :
                                null
                        }
                    </div>
                    {/*결제내역 컨테이너*/}
                    <div style={{
                        minHeight: "600px",
                        border: "solid",
                        borderWidth: "thin 1px",
                        borderColor: "#EAEAEA",
                        borderRadius: "4px",
                        marginTop: "10px"
                    }}>
                        <div style={{
                            borderBottom: "solid",
                            borderWidth: "thin 1px",
                            borderColor: "#EAEAEA",
                            display: "flex",
                            height: "60px",
                            fontSize: "15px",
                            color: "var(--mp-text-sub)",
                            marginBottom: "15px",
                            backgroundColor: "var(--mp-panel)",
                        }}>
                            <div style={{
                                width: "9%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                            }}>
                                <p style={{fontSize: "14px"}}>{t(`myHtDate`)}</p>
                            </div>
                            <div style={{
                                width: "11%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                            }}>
                                <p style={{fontSize: "14px"}}>{t(`ttPr`)}</p>
                            </div>
                            <div style={{
                                width: "10%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                            }}>
                                <p style={{fontSize: "14px"}}>{t(`myUseDep`)}</p>
                            </div>
                            <div style={{
                                width: "7%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                            }}>
                                <p style={{fontSize: "14px"}}>{t(`myUsePt`)}</p>
                            </div>
                            <div style={{
                                width: "7%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                            }}>
                                <p style={{fontSize: "14px", color: "var(--mp-text-sub)"}}>{t(`myUseCp`)}</p>
                            </div>
                            <div style={{
                                width: "7%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                            }}>
                                <p style={{fontSize: "14px", color: "var(--mp-text-sub)"}}>{t(`appSale`)}</p>
                            </div>
                            <div style={{
                                width: "7%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                            }}>
                            </div>
                            <div style={{
                                width: "15%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                            }}>
                                <p style={{fontSize: "14px", color: "var(--mp-text-sub)"}}>{t(`myFnPr`)}</p>
                            </div>
                            <div style={{
                                width: "13%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                            }}>
                                <p style={{fontSize: "14px", color: "var(--mp-text-sub)"}}>{t(`myPt`)}</p> {/*결제수단*/}
                            </div>
                            <div style={{
                                width: "14%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                            }}>
                                <p style={{fontSize: "14px", color: "var(--mp-text-sub)"}}>{t(`modPlHeader5`)}</p> {/*상태*/}
                            </div>
                        </div>
                        {/*아래에 맵핑*/}
                        {sortedPayList.filter(filterStatus).slice(0, payListDisplayLimit).map((pay, index) => (
                            <div key={index} style={{display: "flex", color: "var(--mp-text-sub)", fontSize: "14px", padding: "10px 0"}}>
                                <div style={{
                                    width: "9%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>{formatDate(pay?.regDate)}
                                </div>
                                <div style={{
                                    width: "11%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>{selectedTotalPricePrint(pay).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                </div>
                                <div style={{
                                    width: "10%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>{pay?.depUsePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                </div>
                                <div style={{
                                    width: "7%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>{pay?.pointUsePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                </div>
                                <div style={{
                                    width: "7%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>{pay?.couponUsePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                </div>
                                <div style={{
                                    width: "7%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>{pay?.appSalePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                </div>
                                <div style={{
                                    width: "7%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}>
                                    <div style={{
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        alignItems: "center",
                                    }}>
                                        {pay.payType === "PT3" ?
                                            <button onClick={() => integPayDetail(pay.seqNum)}
                                                    className="bt-btn-C wd-85 font-s-13 m-t-3">{t(`myHtItBt`)}</button>
                                            :
                                            null
                                        } {/*통합내역 버튼*/}
                                    </div>
                                </div>
                                <div
                                    style={{
                                        width: "15%",
                                        display: "flex",
                                        flexDirection: "row", // 기본적으로 한 줄 유지
                                        justifyContent: "center",
                                        alignItems: "center",
                                        textAlign: "center",
                                        flexWrap: "wrap", // 길 경우 줄바꿈
                                        gap: "5px", // 줄바꿈 간 간격
                                    }}
                                >
                                    <p
                                        style={{
                                            margin: 0,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                    >
                                        {pay?.lastPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0}
                                    </p>
                                    {pay.payWay === "PM01" && (
                                        <p
                                            style={{
                                                margin: 0,
                                                color: "darkorange",
                                                fontWeight: "bold",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}
                                        >
                                            {pay?.lastForPrice}
                                        </p>
                                    )}
                                    {pay.payWay === "PM01" && (
                                        <p
                                            style={{
                                                margin: 0,
                                                fontSize: "12px",
                                                color: "var(--mp-text-sub)",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}
                                        >
                                            {pay?.forCurrency}
                                        </p>
                                    )}
                                </div>
                                <div style={{
                                    width: "13%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    textAlign: "center",
                                }}>
                                    {pay.payWay === "PM00" ? t(`modNoBank`) :
                                        pay.payWay === "PM01" ? "Paypal" :
                                            pay.payWay === "PM02" ? "Wechat" :
                                                pay.payWay === "PM03" ? "Alipay" :
                                                    pay.payWay === "PM04" ? "Point" :
                                                        pay.payWay === "PM05" ? "Deposit" :
                                                                pay.payWay === "PM06" ? "BtoragePay(Global)" :
                                                                    pay.payWay === "PM07" ? "BtoragePay(Korean)" :
                                                                        pay.payWay === "PM08" ? "GlobalCard" :
                                                                            pay.payWay === "PM09" ? "KoreanPay" : null}
                                </div>
                                <div style={{
                                    width: "14%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    textAlign: "center",
                                }}>
                                    {pay.payStatus === "PS1" ?
                                        <p style={{
                                            color: "#98B0D4",
                                            fontSize: "15px"
                                        }}>{t(`prodStLabel9`)}</p>
                                        :
                                        pay.payStatus === "PS5" ?
                                            <p style={{
                                                color: "#EB939D",
                                                fontSize: "15px"
                                            }}>{t(`prodStLabel13`)}</p>
                                            :
                                            <p style={{
                                                color: "#FFB378",
                                                fontSize: "15px"
                                            }}>{t(`prodStLabel10`)}</p>}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/*결제내역탭 더보기버튼*/}
                    {
                        payListDisplayLimit && sortedPayList && sortedPayList.length > payListDisplayLimit ?
                            <div className="m-t-20 m-b-50 user-center font-s-17">
                                <button onClick={handleMorePayList}
                                        className="moreBt1 m-r-8 wd-100 ht-40 font-c-default m-r-8 font-s-14">More
                                </button>
                            </div>
                            :
                            null
                    }

                </div>
        },
        {
            label: t(`myTab3`), content:
                <div>
                    <div style={{height: "80px", display: "flex", alignItems: "center", position: "relative"}}>
                        <button style={{
                            height: "40px",
                            minWidth: "200px",
                            borderColor: "lightgray",
                            border: "none",
                            backgroundColor: "var(--mp-panel)",
                            color: "var(--mp-text-sub)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "6px",
                            overflow: "hidden",
                            position: "relative"
                        }} ref={dacPeriodButtonRef}
                                onClick={() => setDacPeriodSelectShow(true)}>{dacPeriodSelectCommonValue}<i style={{
                            fontSize: "27px",
                            position: "absolute",
                            right: "3px",
                            bottom: "2px"
                        }}><BiChevronDown/></i></button>
                        {
                            dacPeriodSelectShow === true ?
                                <div style={{
                                    width: "200px",
                                    height: "auto",
                                    border: "none",
                                    boxShadow: "0px 0px 10px lightgray",
                                    position: "absolute",
                                    left: "0",
                                    top: "70px",
                                    zIndex: 3,
                                    backgroundColor: "var(--mp-surface)",
                                    borderRadius: "6px"
                                }} ref={dacPeriodDivRef} onClick={dacPeriodDivHandle}>
                                    <button className="mypgFilterBt"
                                            onClick={() => dacPeriodBtHandle(t('myPrd1'))}>{t(`myPrd1`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => dacPeriodBtHandle(t('myPrd2'))}>{t(`myPrd2`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => dacPeriodBtHandle(t('myPrd3'))}>{t(`myPrd3`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => dacPeriodBtHandle(t('myPrd4'))}>{t(`myPrd4`)}
                                    </button>
                                    <button className="mypgFilterBt"
                                            onClick={() => dacPeriodBtHandle(t('myPrd5'))}>{t(`myPrd5`)}
                                    </button>
                                </div>
                                :
                                null
                        }
                    </div>
                    <div className="display-flex font-t-cont font-s-16 mp-dac-head">
                        <div style={{width: "35%", height: "40px", margin: "10px 10px 0 10px"}}>
                            <p style={{paddingTop: "10px"}}>{t(`myDepHt`)}</p>
                        </div>
                        <div style={{width: "35%", height: "40px", margin: "10px 10px 0 10px"}}>
                            <p style={{paddingTop: "10px"}}>{t(`myPtHt`)}</p>
                        </div>
                        <div style={{width: "30%", height: "40px", margin: "10px 10px 0 10px"}}>
                            <p style={{paddingTop: "10px"}}>{t(`myCpHt`)}</p>
                        </div>
                    </div>
                    {/*예적쿠내역 컨테이너*/}
                    <div className="font-t-cont display-flex mp-dac-cols">
                        {/*예치금*/}
                        <div style={{
                            width: "35%",
                            minHeight: "500px",
                            border: "solid",
                            margin: "10px",
                            borderWidth: "thin 1px",
                            borderColor: "#EAEAEA",
                            borderRadius: "4px"
                        }}>
                            <p className="mp-dac-title">{t(`myDepHt`)}</p>
                            <div style={{
                                borderBottom: "solid",
                                height: "40px",
                                display: "flex",
                                fontSize: "14px",
                                color: "var(--mp-text-sub)",
                                borderWidth: "thin 1px",
                                borderColor: "#EAEAEA",
                                margin: "10px 0 10px 0"
                            }}>
                                <div style={{
                                    width: "20%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>{t(`myHtDate`)}
                                </div>
                                <div style={{
                                    width: "40%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>{t(`myCont`)}
                                </div>
                                <div style={{
                                    width: "20%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>{t(`myPr`)}
                                </div>
                                <div style={{
                                    width: "20%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>{t(`myBal`)}
                                </div>
                            </div>
                            {sortedDacList.filter(dac => dac.depPrice > 0).slice(0, dacDisplayLimits.deposit).map((dac, index) => (
                                <div key={index} style={{height: "30px", display: "flex", fontSize: "12px"}}>

                                    <div style={{
                                        width: "20%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}>{formatDate(dac?.regDate)}
                                    </div>
                                    <div style={{
                                        width: "40%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        wordBreak: "break-all"
                                    }}><span style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        wordBreak: "break-all"
                                    }}>{dac.content}</span>
                                    </div>
                                    <div style={{
                                        width: "20%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}>{(dac.type === '0' || dac?.type === '2') ? "+" : "-"}{dac?.depPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </div>
                                    <div style={{
                                        width: "20%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}>{dac?.depBalance?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </div>
                                </div>
                            ))}

                            {/*예치금&적립금탭 예치금 더보기버튼*/}
                            {
                                dacDisplayLimits["deposit"] && sortedDacList && sortedDacList.filter(dac => dac.depPrice > 0).length > dacDisplayLimits["deposit"] ?
                                    <div className="m-t-20 m-b-20 user-center font-s-17">
                                        <button onClick={() => handleMoreDacList("deposit")}
                                                className="moreBt1 m-r-8 wd-70 ht-35 font-c-default m-r-8 font-s-12">More
                                        </button>
                                    </div>
                                    :
                                    null
                            }

                        </div>

                        {/*적립금*/}
                        <div style={{
                            width: "35%",
                            minHeight: "500px",
                            border: "solid",
                            margin: "10px",
                            borderWidth: "thin 1px",
                            borderColor: "#EAEAEA",
                            borderRadius: "4px"
                        }}>
                            <p className="mp-dac-title">{t(`myPtHt`)}</p>
                            <div style={{
                                borderBottom: "solid",
                                height: "40px",
                                display: "flex",
                                fontSize: "14px",
                                color: "var(--mp-text-sub)",
                                borderWidth: "thin 1px",
                                borderColor: "#EAEAEA",
                                margin: "10px 0 10px 0"
                            }}>
                                <div style={{
                                    width: "20%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>{t(`myHtDate`)}
                                </div>
                                <div style={{
                                    width: "40%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>{t(`myCont`)}
                                </div>
                                <div style={{
                                    width: "20%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>{t(`myPr`)}
                                </div>
                                <div style={{
                                    width: "20%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>{t(`myBal`)}
                                </div>
                            </div>
                            {sortedDacList.filter(dac => dac.ptPrice > 0).slice(0, dacDisplayLimits.point).map((dac, index) => (
                                <div key={index} style={{height: "30px", display: "flex", fontSize: "12px"}}>

                                    <div style={{
                                        width: "20%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}>{formatDate(dac?.regDate)}
                                    </div>
                                    <div style={{
                                        width: "40%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        wordBreak: "break-all"
                                    }}><span style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        wordBreak: "break-all"
                                    }}>{dac.content}</span>
                                    </div>
                                    <div style={{
                                        width: "20%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}>{(dac.type === '0' || dac?.type === '2') ? "+" : "-"}{dac?.ptPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </div>
                                    <div style={{
                                        width: "20%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}>{dac?.ptBalance?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </div>
                                </div>
                            ))}

                            {/*예치금&적립금탭 적립금 더보기버튼*/}
                            {
                                dacDisplayLimits["point"] && sortedDacList && sortedDacList.filter(dac => dac.ptPrice > 0).length > dacDisplayLimits["point"] ?
                                    <div className="m-t-20 m-b-20 user-center font-s-17">
                                        <button onClick={() => handleMoreDacList("point")}
                                                className="moreBt1 m-r-8 wd-70 ht-35 font-c-default m-r-8 font-s-12">More
                                        </button>
                                    </div>
                                    :
                                    null
                            }

                        </div>

                        {/*쿠폰*/}
                        <div style={{
                            width: "30%",
                            minHeight: "500px",
                            border: "solid",
                            margin: "10px",
                            borderWidth: "thin 1px",
                            borderColor: "#EAEAEA",
                            borderRadius: "4px"
                        }}>
                            <p className="mp-dac-title">{t(`myCpHt`)}</p>
                            <div style={{
                                borderBottom: "solid",
                                height: "40px",
                                display: "flex",
                                fontSize: "14px",
                                color: "var(--mp-text-sub)",
                                borderWidth: "thin 1px",
                                borderColor: "#EAEAEA",
                                margin: "10px 0 10px 0"
                            }}>
                                <div style={{
                                    width: "25%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>{t(`myHtDate`)}
                                </div>
                                <div style={{
                                    width: "50%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>{t(`myCpNm`)}
                                </div>
                                <div style={{
                                    width: "25%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>{t(`myPr`)}
                                </div>
                            </div>
                            {sortedDacList.filter(dac => dac.cpPrice > 0).slice(0, dacDisplayLimits.coupon).map((dac, index) => (
                                <div key={index} style={{height: "30px", display: "flex", fontSize: "12px"}}>

                                    <div style={{
                                        width: "25%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}>{formatDate(dac?.regDate)}
                                    </div>
                                    <div style={{
                                        width: "50%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        wordBreak: "break-all"
                                    }}><span style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        wordBreak: "break-all"
                                    }}>{dac.cpNm}</span>
                                    </div>
                                    <div style={{
                                        width: "25%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}>{(dac.type === '0' || dac?.type === '2') ? "+" : "-"}{dac?.cpPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </div>
                                </div>
                            ))}

                            {/*예치금&적립금탭 쿠폰 더보기버튼*/}
                            {
                                dacDisplayLimits["coupon"] && sortedDacList && sortedDacList.filter(dac => dac.cpPrice > 0).length > dacDisplayLimits["coupon"] ?
                                    <div className="m-t-20 m-b-20 user-center font-s-17">
                                        <button onClick={() => handleMoreDacList("coupon")}
                                                className="moreBt1 m-r-8 wd-70 ht-35 font-c-default m-r-8 font-s-12">More
                                        </button>
                                    </div>
                                    :
                                    null
                            }

                        </div>
                    </div>
                </div>
        },
    ];

    useEffect(() => {
        tabs.forEach((tab) => {
            if (tab.label === t(`myTab1`)) {
                setOrderTypeSelectCommonValue(t('orderType'))
                setOrderStSelectCommonValue(t(`state`));
                setPeriodSelectCommonValue(t('myPrd1'))
            } else if (tab.label === t(`myTab2`)) {
                setPayStSelectCommonValue(t(`state`));
                setPayPeriodSelectCommonValue(t('myPrd1'))
            } else if (tab.label === t(`myTab3`)) {
                setDacPeriodSelectCommonValue(t('myPrd1'))
            }
        })
    }, [i18n.language]);

    return (
        <div className="mypgContainer" data-theme={theme}>
            {/*주문현황*/}
            <div style={{height: "auto"}}>
                <div className="mp-sec-head" style={{display: "flex", alignItems: "flex-start", padding: "10px 0"}}>
                    <img className="wd-25 ht-25" src={commomHeader} alt="header"/>
                    <p className="font-s-20 m-l-10 font-t-title font-c-default">{t(`myOrdPc`)}</p>
                </div>
                <div className="font-t-cont mp-orderstatus" style={{
                    backgroundColor: "var(--mp-panel)",
                    borderRadius: "6px",
                    display: "flex",
                    marginTop: "20px",
                    padding: "70px",
                }}>
                    <div className="mp-os-card" style={{
                        width: "30%",
                        borderRadius: "10px",
                        backgroundColor: "var(--mp-surface)",
                        boxShadow: "0 0 12px 6px rgba(0,0,0,0.03)"
                    }}>
                        <div style={{
                            height: "120px",
                            display: "flex",
                            overflow: "hidden",
                            justifyContent: "center",
                            alignItems: "center",
                        }}><img alt="" src={mypgOrder} style={{width: "80px", height: "80px"}}/></div>
                        <div style={{
                            height: "50px",
                            fontWeight: "bold",
                            fontSize: "18px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "var(--mp-text)",
                        }}>{t(`myOrdPcHeader1`)}
                        </div>
                        <div onClick={() => selectNoDateTotalOrderList("OS00")} style={{
                            width: "240px",
                            margin: "auto",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            color: "var(--mp-text)",
                            cursor: "pointer",
                        }}>
                            <p className="ht-100pc display-flex just-cont-fstart align-center font-s-15">{t(`myPc1`)}</p> {/*입고대기*/}
                            <p className="font-b font-s-17 ht-100pc display-flex just-cont-center align-center"
                               style={{color: processData.OS00 > 0 ? "var(--mp-brand)" : "#5b5b5b"}}>
                                {processData.OS00 || 0}
                            </p>
                        </div>
                        <div onClick={() => selectNoDateTotalOrderList("OS01")} style={{
                            width: "240px",
                            margin: "auto",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            color: "var(--mp-text)",
                            cursor: "pointer"
                        }}>
                            <p className="ht-100pc display-flex just-cont-fstart align-center font-s-15">{t(`myPc2`)}</p> {/*결제대기*/}
                            <p className="font-b font-s-17 ht-100pc display-flex just-cont-center align-center"
                               style={{color: processData.OS01 > 0 ? "var(--mp-brand)" : "#5b5b5b"}}>
                                {processData.OS01 || 0}
                            </p>
                        </div>
                        <div onClick={() => selectNoDateTotalOrderList("OS02")} style={{
                            width: "240px",
                            margin: "auto",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            color: "var(--mp-text)",
                            cursor: "pointer"
                        }}>
                            <p className="ht-100pc display-flex just-cont-fstart align-center font-s-15">{t(`myPc3`)}</p>
                            <p className="font-b font-s-17 ht-100pc display-flex just-cont-center align-center"
                               style={{color: processData.OS02 > 0 ? "var(--mp-brand)" : "#5b5b5b"}}>
                                {processData.OS02 || 0}
                            </p>
                        </div>
                        <div onClick={() => selectNoDateTotalOrderList("OS03")} style={{
                            width: "240px",
                            margin: "auto",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            color: "var(--mp-text)",
                            cursor: "pointer"
                        }}>
                            <p className="ht-100pc display-flex just-cont-fstart align-center font-s-15">{t(`myPc4`)}</p>
                            <p className="font-b font-s-17 ht-100pc display-flex just-cont-center align-center"
                               style={{color: processData.OS03 > 0 ? "var(--mp-brand)" : "#5b5b5b"}}>
                                {processData.OS03 || 0}
                            </p>
                        </div>
                        <div onClick={() => selectNoDateTotalOrderList("OS04")} style={{
                            width: "240px",
                            margin: "auto",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            color: "var(--mp-text)",
                            cursor: "pointer"
                        }}>
                            <p className="ht-100pc display-flex just-cont-fstart align-center font-s-15">{t(`myPc5`)}</p>
                            <p className="font-b font-s-17 ht-100pc display-flex just-cont-center align-center"
                               style={{color: processData.OS04 > 0 ? "var(--mp-brand)" : "#5b5b5b"}}>
                                {processData.OS04 || 0}
                            </p>
                        </div>
                        <div onClick={() => selectNoDateTotalOrderList("OS05")} style={{
                            width: "240px",
                            margin: "auto",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            color: "var(--mp-text)",
                            cursor: "pointer"
                        }}>
                            <p className="ht-100pc display-flex just-cont-fstart align-center font-s-15">{t(`myPc6`)}</p>
                            <p className="font-b font-s-17 ht-100pc display-flex just-cont-center align-center"
                               style={{color: processData.OS05 > 0 ? "var(--mp-brand)" : "#5b5b5b"}}>
                                {processData.OS05 || 0}
                            </p>
                        </div>
                    </div>
                    <div className="mp-os-arrow" style={{
                        width: "5%",
                        color: "var(--mp-text)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                        <i style={{
                            fontSize: "25px",
                            display: "flex",
                            justifyContent: "center",
                            textAlign: "center"
                        }}><AiOutlineDoubleRight style={{color: "var(--mp-text-faint)"}}/></i>
                    </div>
                    <div className="mp-os-card" style={{
                        width: "30%",
                        borderRadius: "10px",
                        backgroundColor: "var(--mp-surface)",
                        boxShadow: "0 0 12px 6px rgba(0,0,0,0.03)"
                    }}>
                        <div style={{
                            height: "120px",
                            display: "flex",
                            overflow: "hidden",
                            justifyContent: "center",
                            alignItems: "center"
                        }}><img alt="" src={mypgDelivery} style={{width: "80px", height: "80px"}}/></div>
                        <div style={{
                            height: "50px",
                            fontWeight: "bold",
                            fontSize: "18px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "var(--mp-text)"
                        }}>{t(`myOrdPcHeader2`)}
                        </div>
                        <div onClick={() => selectNoDateTotalOrderList("OS06")} style={{
                            width: "240px",
                            margin: "auto",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            color: "var(--mp-text)",
                            cursor: "pointer"
                        }}>
                            <p className="ht-100pc display-flex just-cont-fstart align-center font-s-15">{t(`myPc7`)}</p>
                            <p className="font-b font-s-17 ht-100pc display-flex just-cont-center align-center"
                               style={{color: processData.OS06 > 0 ? "var(--mp-brand)" : "#5b5b5b"}}>
                                {processData.OS06 || 0}
                            </p>
                        </div>
                        <div onClick={() => selectNoDateTotalOrderList("OS07")} style={{
                            width: "240px",
                            margin: "auto",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            color: "var(--mp-text)",
                            cursor: "pointer"
                        }}>
                            <p className="ht-100pc display-flex just-cont-fstart align-center font-s-15">{t(`myPc8`)}</p>
                            <p className="font-b font-s-17 ht-100pc display-flex just-cont-center align-center"
                               style={{color: processData.OS07 > 0 ? "var(--mp-brand)" : "#5b5b5b"}}>
                                {processData.OS07 || 0}
                            </p>
                        </div>
                        <div onClick={() => selectNoDateTotalOrderList("OS08")} style={{
                            width: "240px",
                            margin: "auto",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            color: "var(--mp-text)",
                            cursor: "pointer"
                        }}>
                            <p className="ht-100pc display-flex just-cont-fstart align-center font-s-15">{t(`myPc9`)}</p>
                            <p className="font-b font-s-17 ht-100pc display-flex just-cont-center align-center"
                               style={{color: processData.OS08 > 0 ? "var(--mp-brand)" : "#5b5b5b"}}>
                                {processData.OS08 || 0}
                            </p>
                        </div>
                        <div onClick={() => selectNoDateTotalOrderList("PS0")} style={{
                            width: "240px",
                            margin: "auto",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            color: "var(--mp-text)",
                            cursor: "pointer"
                        }}>
                            <p className="ht-100pc display-flex just-cont-fstart align-center font-s-15">{t(`myPc10`)}</p>
                            <p className="font-b font-s-17 ht-100pc display-flex just-cont-center align-center"
                               style={{color: processData.OS09 + processData.PS0 > 0 ? "var(--mp-brand)" : "#5b5b5b"}}>
                                {processData.OS09 + processData.PS0 || 0}
                            </p>
                        </div>
                        <div onClick={() => selectNoDateTotalOrderList("PS1")} style={{
                            width: "240px",
                            margin: "auto",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            color: "var(--mp-text)",
                            cursor: "pointer"
                        }}>
                            <p className="ht-100pc display-flex just-cont-fstart align-center font-s-15">{t(`myPc11`)}</p>
                            <p className="font-b font-s-17 ht-100pc display-flex just-cont-center align-center"
                               style={{color: processData.OS10 + processData.PS1 > 0 ? "var(--mp-brand)" : "#5b5b5b"}}>
                                {processData.OS10 + processData.PS1 || 0}
                            </p>
                        </div>
                        <div onClick={() => selectNoDateTotalOrderList("PS2")} style={{
                            width: "240px",
                            margin: "auto",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            color: "var(--mp-text)",
                            cursor: "pointer"
                        }}>
                            <p className="ht-100pc display-flex just-cont-fstart align-center font-s-15">{t(`myPc12`)}</p>
                            <p className="font-b font-s-17 ht-100pc display-flex just-cont-center align-center"
                               style={{color: processData.OS11 + processData.PS2 > 0 ? "var(--mp-brand)" : "#5b5b5b"}}>
                                {processData.OS11 + processData.PS2 || 0}
                            </p>
                        </div>
                        <div onClick={() => selectNoDateTotalOrderList("PS3")} style={{
                            width: "240px",
                            margin: "auto",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            color: "var(--mp-text)",
                            cursor: "pointer",
                            marginBottom: "20px"
                        }}>
                            <p className="ht-100pc display-flex just-cont-fstart align-center font-s-15">{t(`myPc13`)}</p>
                            <p className="font-b font-s-17 ht-100pc display-flex just-cont-center align-center"
                               style={{color: processData.OS12 + processData.PS3 > 0 ? "var(--mp-brand)" : "#5b5b5b"}}>
                                {processData.OS12 + processData.PS3 || 0}
                            </p>
                        </div>
                    </div>
                    <div className="mp-os-arrow" style={{
                        width: "5%",
                        color: "var(--mp-text)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                        <div style={{fontSize: "20px", display: "flex", justifyContent: "center", textAlign: "center"}}>
                            <img style={{width: "20px", height: "20px", opacity: "0.4"}} alt="" src={mypgReturnIcon}/>
                        </div>
                    </div>
                    <div className="mp-os-card" style={{
                        width: "30%",
                        borderRadius: "10px",
                        backgroundColor: "var(--mp-surface)",
                        boxShadow: "0 0 12px 6px rgba(0,0,0,0.03)"
                    }}>
                        <div style={{
                            height: "120px",
                            display: "flex",
                            overflow: "hidden",
                            justifyContent: "center",
                            alignItems: "center"
                        }}><img alt="" src={mypgReturn} style={{width: "80px", height: "80px"}}/></div>
                        <div style={{
                            height: "50px",
                            fontWeight: "bold",
                            fontSize: "18px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "var(--mp-text)"
                        }}>{t(`myOrdPcHeader3`)}
                        </div>
                        <div onClick={() => selectNoDateTotalOrderList("PS4")} style={{
                            width: "240px",
                            margin: "auto",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            color: "var(--mp-text)",
                            cursor: "pointer"
                        }}>
                            <p className="ht-100pc display-flex just-cont-fstart align-center font-s-15">{t(`myPc14`)}</p>
                            <p className="font-b font-s-17 ht-100pc display-flex just-cont-center align-center"
                               style={{color: processData.OS13 + processData.PS4 > 0 ? "var(--mp-brand)" : "#5b5b5b"}}>
                                {processData.OS13 + processData.PS4 || 0}
                            </p>
                        </div>
                        <div onClick={() => selectNoDateTotalOrderList("PS5")} style={{
                            width: "240px",
                            margin: "auto",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            color: "var(--mp-text)",
                            cursor: "pointer"
                        }}>
                            <p className="ht-100pc display-flex just-cont-fstart align-center font-s-15">{t(`myPc15`)}</p>
                            <p className="font-b font-s-17 ht-100pc display-flex just-cont-center align-center"
                               style={{color: processData.OS14 + processData.PS5 > 0 ? "var(--mp-brand)" : "#5b5b5b"}}>
                                {processData.OS14 + processData.PS5 || 0}
                            </p>
                        </div>
                    </div>
                </div>
                <div>
                    {isMobileView ?
                        /* 모바일: 탭 없이 세로 스택 (앱 MyPg 레이아웃 참고) */
                        <div className="mp-stack font-t-cont">
                            {tabs.map((tab, index) => (
                                <div className="mp-stack-sec" key={index}>
                                    <h3 className="mp-stack-title">{tab.label}</h3>
                                    {/* 결제내역(myTab2)만 가로 스크롤 */}
                                    <div className={`mp-stack-content ${index === 1 ? 'mp-scroll-x' : ''}`}>
                                        {tab.content}
                                    </div>
                                </div>
                            ))}
                        </div>
                        :
                        <div className="tab-menu font-t-cont">
                            <div className="tabs">
                                {tabs.map((tab, index) => (
                                    <button
                                        key={index}
                                        className={`tab ${index === activeTab ? 'active' : ''}`}
                                        onClick={() => {
                                            // 나중에 주문서선택하면 주문서1개월, 결제내역 1개월, 예&적 1개월, 결제내역 선택하면 나머지 1개월, 예&적 선택하면 나머지 1개월 기본세팅 ㄱㄱ
                                            if (tab.label === t(`myTab1`)) {
                                                setPeriodSelectCommonValue(t(`myPrd1`));
                                                setOrderTypeSelectCommonValue(t('orderType'))
                                                setOrderStSelectCommonValue(t(`state`));
                                            }
                                            if (tab.label === t(`myTab2`)) {
                                                setPayPeriodSelectCommonValue(t(`myPrd1`))
                                                setPayStSelectCommonValue(t(`state`));
                                            }
                                            if (tab.label === t(`myTab3`)) {
                                                setDacPeriodSelectCommonValue(t(`myPrd1`))
                                            }

                                            setActiveTab(index);
                                        }}
                                    >
                                        {tab.label}
                                    </button>
                                ))}
                            </div>
                            <div className="content">{tabs[activeTab].content}</div>
                        </div>
                    }
                </div>
            </div>
            {deliveryDetailSt ?
                <DeliveryPriceDetail deliveryDetailSt={deliveryDetailSt} deliveryDetailFalseFn={deliveryDetailFalseFn}
                                     selectedShip={payShipco}
                                     paySeqnum={paySeqnum} updateAppRecinfo={updateAppRecinfo}
                                     updatePayinfoList={updatePayinfoList} pathComponent={pathComponent}/>
                :
                isLoading ?
                    <CommonLoading/>
                    :
                    integPayDetailPopupSt ?
                        <IntegDetailPopup integDetailPopupClose={integDetailPopupClose}
                                          integPaySeqnum={integPaySeqnum}/>
                        :
                        downNoSelectSt ?
                            <MsgCheckModal downNoSelectSt={downNoSelectSt} closeDownNoSelect={closeDownNoSelect}/>
                            :
                            nonSelectedShow ?
                                <MsgCheckModal nonSelectedShow={nonSelectedShow} closeNonSelectedShow={closeNonSelectedShow}/>
                                :
                            null
            }
            <TopBtn/>
        </div>
    )
}

export default withAuth(UserMyPg);
